function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBulletjournalRafiki(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 284.46,
    y: 143.36,
    width: 45.62,
    height: 5.21,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-2--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 284.66,
    y: 204.73,
    width: 45.62,
    height: 5.21,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-3--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 329.96,
    y: 204.73,
    width: 45.62,
    height: 5.21,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-4--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "161.36 301.39 125.7 301.39 125.7 296.18 161.49 296.18 161.36 301.39",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.4,337.8H45.3a5.71,5.71,0,0,1-5.71-5.71V60.66A5.71,5.71,0,0,1,45.3,55H238.4a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,238.4,337.8ZM45.3,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46H238.4a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.7,337.8H261.6a5.71,5.71,0,0,1-5.71-5.71V60.66A5.71,5.71,0,0,1,261.6,55H454.7a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,454.7,337.8ZM261.6,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46H454.7a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.55,
    y: 289.74,
    width: 75.81,
    height: 81.59,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.41,
    y: 283.67,
    width: 9.53,
    height: 98.25,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.62,
    y: 296.17,
    width: 6.21,
    height: 30.49,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.38,
    y: 296.17,
    width: 6.21,
    height: 30.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.83,
    y: 298.31,
    width: 6.21,
    height: 28.35,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.16,
    y: 298.31,
    width: 6.21,
    height: 28.35,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.15,
    y: 296.17,
    width: 4.01,
    height: 30.49,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.05,
    y: 298.31,
    width: 3.11,
    height: 28.35,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.59,
    y: 296.17,
    width: 6.21,
    height: 30.49,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.8,
    y: 298.31,
    width: 6.21,
    height: 28.35,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.13,
    y: 298.31,
    width: 6.21,
    height: 28.35,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.12,
    y: 296.17,
    width: 4.01,
    height: 30.49,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.01,
    y: 298.31,
    width: 3.11,
    height: 28.35,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.34,
    y: 296.89,
    width: 3.11,
    height: 29.77,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.24,
    y: 337.03,
    width: 6.21,
    height: 30.49,
    transform: "translate(402.68 704.56) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.48,
    y: 337.03,
    width: 6.21,
    height: 30.49,
    transform: "translate(351.17 704.56) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.02,
    y: 339.18,
    width: 6.21,
    height: 28.35,
    transform: "translate(390.26 706.7) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.69,
    y: 339.18,
    width: 6.21,
    height: 28.35,
    transform: "translate(363.6 706.7) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.9,
    y: 337.03,
    width: 4.01,
    height: 30.49,
    transform: "translate(373.82 704.56) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.92,
    y: 339.18,
    width: 3.11,
    height: 28.35,
    transform: "translate(380.94 706.7) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.27,
    y: 337.03,
    width: 6.21,
    height: 30.49,
    transform: "translate(338.75 704.56) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.06,
    y: 339.18,
    width: 6.21,
    height: 28.35,
    transform: "translate(326.33 706.7) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.73,
    y: 339.18,
    width: 6.21,
    height: 28.35,
    transform: "translate(299.67 706.7) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.94,
    y: 337.03,
    width: 4.01,
    height: 30.49,
    transform: "translate(309.89 704.56) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.61,
    y: 337.03,
    width: 4.01,
    height: 30.49,
    transform: "translate(283.23 704.56) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.95,
    y: 339.18,
    width: 3.11,
    height: 28.35,
    transform: "translate(317.01 706.7) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.62,
    y: 337.76,
    width: 3.11,
    height: 29.77,
    transform: "translate(290.35 705.28) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207,283.67H129.15v92.75h75.29v5.51h5.08V283.67Zm-2.54,83.86H134V331.77h70.49Zm0-40.84H134V292.57h70.49Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.62,
    y: 289.74,
    width: 75.81,
    height: 81.59,
    transform: "translate(187.06 661.08) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.54,
    y: 375.42,
    width: 9.53,
    height: 6.5,
    transform: "translate(126.61 757.35) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.67,
    y: 296.17,
    width: 6.21,
    height: 30.49,
    transform: "translate(251.54 622.82) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.91,
    y: 296.17,
    width: 6.21,
    height: 30.49,
    transform: "translate(200.04 622.82) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.45,
    y: 298.31,
    width: 6.21,
    height: 28.35,
    transform: "translate(239.12 624.97) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.12,
    y: 298.31,
    width: 6.21,
    height: 28.35,
    transform: "translate(212.46 624.97) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.33,
    y: 296.17,
    width: 4.01,
    height: 30.49,
    transform: "translate(222.68 622.82) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.35,
    y: 298.31,
    width: 3.11,
    height: 28.35,
    transform: "translate(229.8 624.97) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.8,
    y: 296.17,
    width: 6.21,
    height: 30.49,
    transform: "translate(195.8 622.82) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.58,
    y: 298.31,
    width: 6.21,
    height: 28.35,
    transform: "translate(183.38 624.97) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.25,
    y: 298.31,
    width: 6.21,
    height: 28.35,
    transform: "translate(156.72 624.97) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.46,
    y: 296.17,
    width: 4.01,
    height: 30.49,
    transform: "translate(166.94 622.82) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.48,
    y: 298.31,
    width: 3.11,
    height: 28.35,
    transform: "translate(174.06 624.97) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.15,
    y: 296.89,
    width: 3.11,
    height: 29.77,
    transform: "translate(147.4 623.55) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.23,
    y: 337.03,
    width: 6.21,
    height: 30.49,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.98,
    y: 337.03,
    width: 6.21,
    height: 30.49,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.44,
    y: 339.18,
    width: 6.21,
    height: 28.35,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.77,
    y: 339.18,
    width: 6.21,
    height: 28.35,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.76,
    y: 337.03,
    width: 4.01,
    height: 30.49,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.65,
    y: 339.18,
    width: 3.11,
    height: 28.35,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.1,
    y: 337.03,
    width: 6.21,
    height: 30.49,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.31,
    y: 339.18,
    width: 6.21,
    height: 28.35,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.64,
    y: 339.18,
    width: 6.21,
    height: 28.35,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.63,
    y: 337.03,
    width: 4.01,
    height: 30.49,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.14,
    y: 337.03,
    width: 4.01,
    height: 30.49,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.52,
    y: 339.18,
    width: 3.11,
    height: 28.35,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.85,
    y: 337.76,
    width: 3.11,
    height: 29.77,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.47,283.67v98.26h5.08v-5.51h75.28V283.67H53.47Zm5.08,48.1H129v35.76H58.55Zm0-39.2H129v34.12H58.55Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.61,
    y: 187.03,
    width: 6.18,
    height: 196.12,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "389.79 383.16 385.36 383.16 393.1 192.03 397.54 192.03 389.79 383.16",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "427.35 383.16 431.78 383.16 424.04 192.03 419.6 192.03 427.35 383.16",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "436.93 277.43 379 277.43 384.58 197.68 442.5 197.68 436.93 277.43",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "384.03 205.58 392.49 197.68 384.58 197.68 384.03 205.58",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "434.6 197.68 441.95 205.58 442.5 197.68 434.6 197.68",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "379 277.43 386.91 277.43 379.56 269.52 379 277.43",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "437.48 269.52 429.02 277.43 436.93 277.43 437.48 269.52",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.81,258.49S383.88,241.08,389.87,235,400.81,258.49,400.81,258.49Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405,250.64s-3.29-38.7,5.64-37.7S405,250.64,405,250.64Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.08,254.84s10.7-21.34,19.53-17.29S411.08,254.84,411.08,254.84Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.31,
    y: 276.49,
    width: 74.03,
    height: 10.51,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.46,
    y: 312,
    width: 46.06,
    height: 5.01,
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-2",
    cx: 250,
    cy: 415.69,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--bullet-journal--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M404.19,70H246.37v7.23H396.58A20.74,20.74,0,0,1,417.33,98V290.49a20.75,20.75,0,0,1-20.75,20.75H246.37v7.23H404.19a20.75,20.75,0,0,0,20.75-20.75v-207A20.75,20.75,0,0,0,404.19,70Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.58,311.24a20.75,20.75,0,0,0,20.75-20.75V98a20.74,20.74,0,0,0-20.75-20.74H246.37v234Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.58,311.24a20.75,20.75,0,0,0,20.75-20.75V98a20.74,20.74,0,0,0-20.75-20.74H246.37v234Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.16,311.24a20.75,20.75,0,0,1-20.75-20.75V98A20.74,20.74,0,0,1,96.16,77.21H246.37V70H88.55A20.75,20.75,0,0,0,67.8,90.73v207a20.75,20.75,0,0,0,20.75,20.75H246.37v-7.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.41,98V290.49a20.75,20.75,0,0,0,20.75,20.75H246.37v-234H96.16A20.74,20.74,0,0,0,75.41,98Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.41,98V290.49a20.75,20.75,0,0,0,20.75,20.75H246.37v-234H96.16A20.74,20.74,0,0,0,75.41,98Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.07,194.87c.72-1.25,2.61-1.35,3.39-2.55a3.7,3.7,0,0,1-2.65.77c.06-.32-.41-.52-.55-.8,3.08-1.75,5.57-3.31,8.28-5.11a3.23,3.23,0,0,1,1.32-.63,1,1,0,0,1,1.13.8,9.51,9.51,0,0,0,3.09-1.26,4.13,4.13,0,0,1,3.06-.38L199,187.64a.71.71,0,0,0-.3.51.45.45,0,0,0,.4.38,1.11,1.11,0,0,0,.59-.11,5.18,5.18,0,0,0,1.45-.77,12.84,12.84,0,0,1-1.44,1.83c.63-.37,1.2-.28,1.83-.65-.71.69-.82.94-1.46,1.63.36.35,0,1.45-.18,1.91a4.45,4.45,0,0,1-1.58,1.73,35.59,35.59,0,0,1-7.38,4.24c-.39-.08-.57-.35-1-.32a.54.54,0,0,0,.08-.41,13.44,13.44,0,0,0,1.58-1.62,2.5,2.5,0,0,0-1.57.49l-2.68,1.59c-.1.06,0-.47.08-.59s.15-.19.25-.26a8.26,8.26,0,0,0,2.16-2.09,36.37,36.37,0,0,0-4.13,1.38,11.5,11.5,0,0,0,1.43-2.13C186.16,194.61,183.61,195.77,184.07,194.87Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.27,157.17l.43-1a2.65,2.65,0,0,0,1.49.49c.53,0,.74-.16.74-.4,0-.79-2.57-.22-2.54-2,0-.88.69-1.6,2-1.6a3.12,3.12,0,0,1,1.63.43l-.41,1a2.4,2.4,0,0,0-1.24-.38c-.54,0-.74.19-.74.44,0,.75,2.56.19,2.53,2,0,.86-.68,1.59-2,1.59A3.23,3.23,0,0,1,106.27,157.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.82,157.62l0-2.62-1.19,2.13h-.57L125,155.07l0,2.55h-1.18l.07-4.94h1.06l1.54,2.85,1.59-2.85h1.06l-.07,4.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.51,153.79h-1.39l0-1.11h4.05l0,1.11h-1.38l-.06,3.83h-1.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.53,152.68,164,157.62h-1.37l-.82-3-1,3h-1.37l-1.39-4.94h1.32l.86,3.15,1-3.15h1.17l.86,3.18,1-3.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.27,153.79h-1.39l0-1.11h4v1.11h-1.39l-.06,3.83h-1.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.46,153.76l0,1.08h2l0,1.08h-2l0,1.7h-1.28l.08-4.94h3.54v1.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.69,157.17l.44-1a2.62,2.62,0,0,0,1.48.49c.53,0,.74-.16.74-.4,0-.79-2.56-.22-2.53-2,0-.88.68-1.6,2-1.6a3.16,3.16,0,0,1,1.64.43l-.41,1a2.43,2.43,0,0,0-1.25-.38c-.54,0-.73.19-.74.44,0,.75,2.56.19,2.53,2,0,.86-.68,1.59-2,1.59A3.27,3.27,0,0,1,208.69,157.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.07,164.84l-.08,4.94h-1.27l.06-3.86h-.84l0-1.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.45,168.67l0,1.11h-3.52l0-.88,1.71-1.73a1.06,1.06,0,0,0,.43-.79c0-.32-.19-.51-.57-.51a.93.93,0,0,0-.82.48l-.94-.58a2.08,2.08,0,0,1,1.89-1c1,0,1.75.59,1.73,1.5a2.07,2.07,0,0,1-.79,1.57l-.87.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.32,168.23c0,.84-.63,1.65-2,1.65a3.17,3.17,0,0,1-1.75-.49l.48-1a2.12,2.12,0,0,0,1.24.41c.44,0,.72-.19.73-.52s-.19-.48-.68-.48h-.54v-.88l.83-1h-1.78v-1.08h3.27l0,.87-.95,1.1A1.37,1.37,0,0,1,178.32,168.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196,168.83h-.67l0,.95H194v-.95h-2.38v-.91l2.08-3.08h1.32l-1.89,2.88h.92v-.84h1.21v.84H196Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.15,168.19c0,.88-.63,1.69-2,1.69a3.16,3.16,0,0,1-1.74-.49l.48-1a2.09,2.09,0,0,0,1.24.41c.44,0,.73-.19.73-.53s-.17-.5-.87-.5h-1.22l.27-2.88h2.88l0,1.08h-1.82l-.07.72h.31C211.65,166.64,212.16,167.32,212.15,168.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.85,180.35A1.71,1.71,0,0,1,108,182c-1.26,0-2.07-.83-2.05-2.44a2.43,2.43,0,0,1,2.45-2.7,2.36,2.36,0,0,1,1.32.36l-.48,1a1.35,1.35,0,0,0-.83-.25,1.13,1.13,0,0,0-1.16,1.15,1.46,1.46,0,0,1,1-.37A1.49,1.49,0,0,1,109.85,180.35Zm-1.24.07a.57.57,0,0,0-.61-.62.61.61,0,0,0-.64.62.58.58,0,0,0,.62.62A.6.6,0,0,0,108.61,180.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.87,177v.88l-1.66,4.06h-1.39l1.58-3.83H124.2v.76H123.1l0-1.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.79,180.49c0,.94-.82,1.55-2,1.55s-2-.61-1.94-1.55a1.32,1.32,0,0,1,.66-1.15,1.23,1.23,0,0,1-.46-1c0-.87.76-1.44,1.82-1.44s1.79.57,1.78,1.44a1.29,1.29,0,0,1-.5,1A1.29,1.29,0,0,1,144.79,180.49Zm-1.29-.05a.59.59,0,0,0-.67-.61.61.61,0,0,0-.68.61.59.59,0,0,0,.66.62A.62.62,0,0,0,143.5,180.44Zm-1.18-2a.48.48,0,0,0,.53.51.5.5,0,0,0,.55-.51.5.5,0,0,0-.54-.53A.51.51,0,0,0,142.32,178.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.53,179.34a2.42,2.42,0,0,1-2.45,2.7,2.33,2.33,0,0,1-1.31-.36l.48-1a1.3,1.3,0,0,0,.82.25,1.12,1.12,0,0,0,1.16-1.14,1.55,1.55,0,0,1-2.55-1.2,1.7,1.7,0,0,1,1.8-1.69C160.75,176.9,161.56,177.74,161.53,179.34Zm-1.36-.82a.59.59,0,0,0-.63-.62.59.59,0,0,0-.62.62.57.57,0,0,0,.61.63A.62.62,0,0,0,160.17,178.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.64,177l-.08,4.94h-1.28l.06-3.86h-.84l0-1.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.28,179.47c0-1.63.88-2.57,2-2.57s2,.94,1.95,2.57-.88,2.57-2,2.57S177.25,181.1,177.28,179.47Zm2.69,0c0-1-.27-1.42-.68-1.42s-.71.38-.73,1.42.27,1.43.69,1.43S180,180.51,180,179.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.52,177l-.08,4.94h-1.28l.06-3.86h-.84l0-1.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.13,177l-.08,4.94h-1.28l.07-3.86H194V177Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.39,177l-.07,4.94H209l.06-3.86h-.84l0-1.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.5,180.83v1.11H211v-.88l1.72-1.72a1.13,1.13,0,0,0,.43-.8c0-.32-.19-.51-.58-.51a.93.93,0,0,0-.81.48l-.94-.58a2.07,2.07,0,0,1,1.89-1,1.53,1.53,0,0,1,1.73,1.51,2.1,2.1,0,0,1-.79,1.56l-.87.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.78,189.16l-.08,4.94h-1.28l.06-3.86h-.84l0-1.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.88,192.55c0,.84-.63,1.65-2,1.65a3.16,3.16,0,0,1-1.74-.49l.48-1.05a2.09,2.09,0,0,0,1.24.41c.44,0,.72-.18.73-.52s-.19-.48-.69-.48h-.53v-.88l.82-.95h-1.78l0-1.08h3.27l0,.88-1,1.1A1.35,1.35,0,0,1,111.88,192.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.94,189.16l-.08,4.94h-1.27l.06-3.86h-.84l0-1.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.82,193.15h-.67l0,.95h-1.24v-.95h-2.39l0-.91,2.07-3.08h1.33L127,192.05H128v-.84h1.21v.84h.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.68,189.16l-.08,4.94h-1.27l.06-3.86h-.84l0-1.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.86,192.51a1.75,1.75,0,0,1-2,1.69,3.16,3.16,0,0,1-1.74-.49l.48-1.05a2.09,2.09,0,0,0,1.24.41c.43,0,.73-.19.73-.52s-.18-.5-.87-.5h-1.22l.27-2.89h2.88l0,1.08h-1.82l-.07.72H145C146.36,191,146.87,191.64,146.86,192.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.56,189.16l-.08,4.94h-1.27l.06-3.86h-.84l0-1.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.05,192.51a1.7,1.7,0,0,1-1.8,1.69c-1.26,0-2.08-.83-2.05-2.44a2.42,2.42,0,0,1,2.44-2.7,2.39,2.39,0,0,1,1.33.36l-.48,1a1.35,1.35,0,0,0-.83-.25,1.11,1.11,0,0,0-1.16,1.15,1.43,1.43,0,0,1,1-.37A1.48,1.48,0,0,1,164.05,192.51Zm-1.24.06a.57.57,0,0,0-.61-.62.61.61,0,0,0-.63.63.57.57,0,0,0,.62.62A.59.59,0,0,0,162.81,192.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.44,189.16l-.08,4.94h-1.27l.06-3.86h-.84v-1.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.79,189.16V190l-1.66,4.06h-1.39l1.58-3.83h-1.19V191H177l0-1.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.32,189.16l-.08,4.94H192l.07-3.86h-.84v-1.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.84,192.65c0,.94-.82,1.55-2,1.55s-2-.61-1.94-1.55a1.32,1.32,0,0,1,.66-1.15,1.23,1.23,0,0,1-.47-1c0-.87.76-1.44,1.83-1.44s1.79.57,1.78,1.44a1.29,1.29,0,0,1-.5,1A1.27,1.27,0,0,1,197.84,192.65Zm-1.28-.05a.59.59,0,0,0-.67-.61.62.62,0,0,0-.69.61.6.6,0,0,0,.67.62A.62.62,0,0,0,196.56,192.6Zm-1.18-2a.48.48,0,0,0,.53.52.51.51,0,0,0,.55-.52.54.54,0,0,0-1.08,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.2,189.16l-.08,4.94h-1.28l.06-3.86h-.83v-1.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.59,191.5a2.43,2.43,0,0,1-2.45,2.7,2.38,2.38,0,0,1-1.32-.36l.48-1a1.35,1.35,0,0,0,.83.25,1.13,1.13,0,0,0,1.16-1.14,1.55,1.55,0,0,1-2.55-1.2,1.69,1.69,0,0,1,1.79-1.69C213.8,189.06,214.62,189.89,214.59,191.5Zm-1.37-.82a.57.57,0,0,0-.62-.62.59.59,0,0,0-.62.62.57.57,0,0,0,.61.63A.61.61,0,0,0,213.22,190.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.21,201.1c-.7,1.15-2.48,1.2-3.24,2.31a3.43,3.43,0,0,1,2.5-.66c0,.3.38.5.51.77-2.94,1.57-5.31,3-7.9,4.6a3.1,3.1,0,0,1-1.26.56,1,1,0,0,1-1-.78,8.57,8.57,0,0,0-2.93,1.11,3.87,3.87,0,0,1-2.89.28l2.07-1.76c.14-.13.3-.28.29-.47a.41.41,0,0,0-.37-.37,1.07,1.07,0,0,0-.55.09,5,5,0,0,0-1.38.69,12.52,12.52,0,0,1,1.39-1.68c-.6.33-1.13.23-1.73.56.68-.63.79-.86,1.41-1.49-.33-.34,0-1.37.21-1.79a4.16,4.16,0,0,1,1.53-1.59,32.56,32.56,0,0,1,7-3.8c.36.07.52.34.89.32a.52.52,0,0,0-.09.38,12.58,12.58,0,0,0-1.52,1.49,2.37,2.37,0,0,0,1.48-.43l2.56-1.42c.1-.06,0,.43-.08.54a.53.53,0,0,1-.25.24,7.76,7.76,0,0,0-2.08,1.92,34.83,34.83,0,0,0,3.92-1.2,10.64,10.64,0,0,0-1.4,2C116.25,201.29,118.67,200.26,118.21,201.1Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.6,206.77c.72-1.24,2.61-1.34,3.39-2.54a3.67,3.67,0,0,1-2.64.76c.05-.32-.42-.51-.56-.8,3.08-1.75,5.57-3.31,8.28-5.11a3.2,3.2,0,0,1,1.33-.63,1,1,0,0,1,1.12.81,9.32,9.32,0,0,0,3.09-1.27,4.08,4.08,0,0,1,3.06-.37l-2.15,1.93a.69.69,0,0,0-.3.5.46.46,0,0,0,.4.39,1.12,1.12,0,0,0,.59-.12,5,5,0,0,0,1.45-.76,13.28,13.28,0,0,1-1.44,1.82c.64-.36,1.2-.28,1.83-.64-.71.68-.82.94-1.46,1.62.36.35,0,1.45-.17,1.92a4.54,4.54,0,0,1-1.59,1.73,35.55,35.55,0,0,1-7.38,4.23c-.38-.07-.57-.35-1-.32a.54.54,0,0,0,.08-.41,12.1,12.1,0,0,0,1.58-1.62,2.46,2.46,0,0,0-1.56.5c-.9.52-1.79,1.05-2.68,1.58-.11.06,0-.46.07-.58a.59.59,0,0,1,.25-.27,8.1,8.1,0,0,0,2.16-2.09,37,37,0,0,0-4.13,1.38,11.71,11.71,0,0,0,1.44-2.13C153.69,206.52,151.14,207.67,151.6,206.77Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.07,205.15v1.11h-3.52v-.88l1.72-1.72a1.13,1.13,0,0,0,.43-.8c0-.32-.19-.51-.58-.51a.93.93,0,0,0-.81.48l-.94-.58a2.07,2.07,0,0,1,1.89-1c1,0,1.75.59,1.73,1.51a2.1,2.1,0,0,1-.79,1.56l-.87.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.47,203.79c0-1.63.88-2.57,2-2.57s2,.94,2,2.57-.88,2.57-2,2.57S109.44,205.42,109.47,203.79Zm2.69,0c0-1-.27-1.42-.68-1.42s-.71.38-.73,1.42.27,1.43.69,1.43S112.15,204.83,112.16,203.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.24,205.15v1.11h-3.52v-.88l1.72-1.72a1.13,1.13,0,0,0,.43-.8c0-.32-.19-.51-.58-.51a.91.91,0,0,0-.81.48l-.94-.58a2.07,2.07,0,0,1,1.89-1,1.53,1.53,0,0,1,1.73,1.51,2.1,2.1,0,0,1-.79,1.56l-.87.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.62,201.32l-.08,4.94h-1.28l.06-3.86h-.84l0-1.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144,205.15v1.11h-3.52v-.88l1.72-1.72a1.13,1.13,0,0,0,.43-.8c0-.32-.19-.51-.58-.51a.91.91,0,0,0-.81.48l-.94-.58a2.07,2.07,0,0,1,1.89-1,1.53,1.53,0,0,1,1.73,1.51,2.1,2.1,0,0,1-.79,1.56l-.87.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.85,205.15l0,1.11h-3.51v-.88l1.72-1.72a1.07,1.07,0,0,0,.42-.8c0-.32-.18-.51-.57-.51a.91.91,0,0,0-.81.48l-.94-.58a2.07,2.07,0,0,1,1.89-1,1.53,1.53,0,0,1,1.73,1.51,2.09,2.09,0,0,1-.8,1.56l-.86.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.86,205.15l0,1.11h-3.51v-.88l1.72-1.72a1.13,1.13,0,0,0,.43-.8c0-.32-.19-.51-.58-.51a.91.91,0,0,0-.81.48l-.94-.58a2.07,2.07,0,0,1,1.89-1,1.53,1.53,0,0,1,1.73,1.51,2.09,2.09,0,0,1-.8,1.56l-.86.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.72,204.71c0,.84-.63,1.65-2,1.65a3.17,3.17,0,0,1-1.75-.49l.48-1.05a2.12,2.12,0,0,0,1.25.41c.43,0,.72-.18.72-.52s-.19-.48-.68-.48h-.54l0-.88.82-.95h-1.78l0-1.08h3.26v.88l-1,1.1A1.34,1.34,0,0,1,164.72,204.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.74,205.15l0,1.11h-3.51v-.88l1.72-1.72a1.07,1.07,0,0,0,.42-.8c0-.32-.18-.51-.57-.51a.91.91,0,0,0-.81.48l-.94-.58a2.07,2.07,0,0,1,1.89-1,1.53,1.53,0,0,1,1.73,1.51,2.09,2.09,0,0,1-.8,1.56l-.86.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.34,205.31h-.67v.95h-1.25l0-.95H178v-.91l2.08-3.08h1.32l-1.88,2.89h.91l0-.84h1.2v.84h.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.62,205.15l0,1.11h-3.51v-.88l1.72-1.72a1.11,1.11,0,0,0,.42-.8c0-.32-.18-.51-.57-.51a.91.91,0,0,0-.81.48l-.94-.58a2.05,2.05,0,0,1,1.88-1,1.54,1.54,0,0,1,1.74,1.51,2.09,2.09,0,0,1-.8,1.56l-.86.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.55,204.67a1.74,1.74,0,0,1-2,1.69,3.12,3.12,0,0,1-1.74-.49l.47-1.05a2.15,2.15,0,0,0,1.25.41c.43,0,.72-.19.73-.52s-.18-.5-.87-.5h-1.23l.28-2.89h2.87v1.08h-1.82l-.07.72h.3C198.06,203.12,198.57,203.8,198.55,204.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.5,205.15l0,1.11H208l0-.88,1.72-1.72a1.11,1.11,0,0,0,.42-.8c0-.32-.18-.51-.57-.51a.91.91,0,0,0-.81.48l-.94-.58a2.05,2.05,0,0,1,1.88-1,1.54,1.54,0,0,1,1.74,1.51,2.09,2.09,0,0,1-.8,1.56l-.86.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.74,204.67a1.7,1.7,0,0,1-1.8,1.69c-1.26,0-2.08-.83-2.05-2.44a2.42,2.42,0,0,1,2.44-2.7,2.39,2.39,0,0,1,1.33.36l-.48,1a1.35,1.35,0,0,0-.83-.25,1.12,1.12,0,0,0-1.16,1.15,1.43,1.43,0,0,1,1-.37A1.48,1.48,0,0,1,215.74,204.67Zm-1.24.07a.57.57,0,0,0-.61-.63.6.6,0,0,0-.63.63.57.57,0,0,0,.62.62A.59.59,0,0,0,214.5,204.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.88,217.31l0,1.11h-3.52l0-.87,1.72-1.73a1.11,1.11,0,0,0,.42-.8c0-.32-.18-.51-.57-.51a.91.91,0,0,0-.81.48l-.94-.58a2.05,2.05,0,0,1,1.88-1,1.54,1.54,0,0,1,1.74,1.51,2.07,2.07,0,0,1-.8,1.56l-.86.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113,213.48v.88l-1.66,4.06h-1.39l1.58-3.83h-1.19v.76h-1.09l0-1.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.05,217.31l0,1.11h-3.52l0-.87,1.72-1.73a1.11,1.11,0,0,0,.42-.8c0-.32-.18-.51-.57-.51a.93.93,0,0,0-.82.48l-.94-.58a2.08,2.08,0,0,1,1.89-1c1,0,1.75.59,1.73,1.51a2,2,0,0,1-.79,1.56l-.86.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.33,217c0,.94-.82,1.55-2,1.55s-2-.61-1.94-1.55a1.33,1.33,0,0,1,.67-1.15,1.19,1.19,0,0,1-.47-1c0-.87.76-1.44,1.82-1.44s1.8.57,1.78,1.44a1.24,1.24,0,0,1-.5,1A1.27,1.27,0,0,1,130.33,217Zm-1.29-.05a.59.59,0,0,0-.66-.61.62.62,0,0,0-.69.61.59.59,0,0,0,.67.62A.61.61,0,0,0,129,216.92Zm-1.18-2a.48.48,0,0,0,.53.51.5.5,0,0,0,.55-.51.49.49,0,0,0-.53-.53A.51.51,0,0,0,127.86,214.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.79,217.31l0,1.11h-3.52l0-.87,1.72-1.73a1.11,1.11,0,0,0,.42-.8c0-.32-.18-.51-.57-.51a.93.93,0,0,0-.82.48l-.93-.58a2.05,2.05,0,0,1,1.88-1c1,0,1.75.59,1.73,1.51a2,2,0,0,1-.79,1.56l-.86.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.94,215.82a2.43,2.43,0,0,1-2.45,2.7,2.36,2.36,0,0,1-1.32-.36l.48-1a1.29,1.29,0,0,0,.83.25,1.11,1.11,0,0,0,1.15-1.14,1.46,1.46,0,0,1-1,.36,1.49,1.49,0,0,1-1.53-1.56,1.71,1.71,0,0,1,1.8-1.69C147.15,213.38,148,214.22,147.94,215.82Zm-1.37-.82a.57.57,0,0,0-.62-.62.6.6,0,0,0-.63.63.58.58,0,0,0,.61.62A.62.62,0,0,0,146.57,215Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.66,216.88c0,.83-.63,1.64-2,1.64a3.17,3.17,0,0,1-1.75-.49l.48-1.05a2.12,2.12,0,0,0,1.25.41c.43,0,.71-.18.72-.51s-.19-.48-.68-.48h-.54l0-.89.82-.95h-1.78v-1.08h3.27v.88l-1,1.1A1.35,1.35,0,0,1,160.66,216.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.09,216c0-1.63.88-2.57,2-2.57s2,.94,1.94,2.57-.88,2.57-2,2.57S161.06,217.58,161.09,216Zm2.7,0c0-1-.28-1.42-.68-1.42s-.72.38-.73,1.42.27,1.43.68,1.43S163.77,217,163.79,216Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.67,253.37l.88,1.55h-1l-.8-1.43h-1.22l-.28,1.43h-.92l1-4.9h1.91c1.18,0,1.86.55,1.86,1.48A1.83,1.83,0,0,1,270.67,253.37Zm.52-1.79c0-.53-.38-.79-1-.79h-1l-.39,2h1.09C270.68,252.74,271.19,252.34,271.19,251.58Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.25,253.31h-3c0,.6.36.92,1.08.92a1.55,1.55,0,0,0,1.08-.39l.36.61a2.31,2.31,0,0,1-1.53.52,1.63,1.63,0,0,1-1.84-1.64,2.1,2.1,0,0,1,2.16-2.19,1.57,1.57,0,0,1,1.72,1.64A2.2,2.2,0,0,1,276.25,253.31Zm-2.89-.58h2.14a.85.85,0,0,0-1-.89A1.18,1.18,0,0,0,273.36,252.73Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.44,252.39a2,2,0,0,1-.05.46l-.41,2.07h-.88l.42-2a1.5,1.5,0,0,0,0-.29c0-.44-.24-.67-.72-.67s-1,.34-1.15,1.07l-.39,1.94h-.88l.42-2a1.5,1.5,0,0,0,0-.29c0-.44-.23-.67-.72-.67s-1,.34-1.15,1.07l-.39,1.94h-.87l.74-3.74h.83l-.08.41a1.75,1.75,0,0,1,1.23-.45,1.2,1.2,0,0,1,1.16.62,1.94,1.94,0,0,1,1.48-.62A1.19,1.19,0,0,1,283.44,252.39Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288,253.31h-3c0,.6.36.92,1.08.92a1.55,1.55,0,0,0,1.08-.39l.36.61A2.31,2.31,0,0,1,286,255a1.63,1.63,0,0,1-1.84-1.64,2.1,2.1,0,0,1,2.15-2.19,1.57,1.57,0,0,1,1.73,1.64A2.2,2.2,0,0,1,288,253.31Zm-2.89-.58h2.14a.85.85,0,0,0-1-.89A1.18,1.18,0,0,0,285.1,252.73Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.18,252.39a2,2,0,0,1-.05.46l-.41,2.07h-.88l.42-2a1.46,1.46,0,0,0,0-.29c0-.44-.23-.67-.71-.67s-1,.34-1.15,1.07l-.39,1.94h-.88l.42-2a1.5,1.5,0,0,0,0-.29c0-.44-.24-.67-.72-.67s-1,.34-1.15,1.07l-.39,1.94h-.88l.75-3.74H290l-.08.41a1.75,1.75,0,0,1,1.23-.45,1.2,1.2,0,0,1,1.16.62,1.94,1.94,0,0,1,1.48-.62A1.19,1.19,0,0,1,295.18,252.39Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.2,252.78a2.09,2.09,0,0,1-2.1,2.19,1.39,1.39,0,0,1-1.31-.64l-.12.59h-.83l1-5.19h.88l-.36,1.8a1.8,1.8,0,0,1,1.16-.39A1.56,1.56,0,0,1,300.2,252.78Zm-.88,0a.89.89,0,0,0-1-.94,1.31,1.31,0,0,0-1.29,1.41.88.88,0,0,0,1,.93A1.3,1.3,0,0,0,299.32,252.82Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.5,253.31h-3c0,.6.35.92,1.08.92a1.54,1.54,0,0,0,1.07-.39l.37.61a2.32,2.32,0,0,1-1.54.52,1.64,1.64,0,0,1-1.84-1.64,2.1,2.1,0,0,1,2.16-2.19,1.57,1.57,0,0,1,1.72,1.64A2.89,2.89,0,0,1,304.5,253.31Zm-2.9-.58h2.15a.86.86,0,0,0-1-.89A1.19,1.19,0,0,0,301.6,252.73Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.89,251.14l-.16.83-.22,0a1.22,1.22,0,0,0-1.29,1.13l-.37,1.84H305l.74-3.74h.84l-.1.49A1.73,1.73,0,0,1,307.89,251.14Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.54,251.5c0,1.25-.9,2-2.34,2H346l-.28,1.41h-.91l1-4.9h1.89C348.86,250,349.54,250.57,349.54,251.5Zm-.92.08c0-.53-.37-.79-1-.79h-1l-.38,2h1.08C348.12,252.74,348.62,252.34,348.62,251.58Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.62,251.14l-.16.83-.22,0a1.22,1.22,0,0,0-1.29,1.13l-.37,1.84h-.88l.74-3.74h.84l-.1.49A1.73,1.73,0,0,1,352.62,251.14Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.35,251.18h.87l-.74,3.74h-.88Zm.11-1.1a.55.55,0,0,1,.59-.56.49.49,0,0,1,.53.47.56.56,0,0,1-.6.58A.5.5,0,0,1,353.46,250.08Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.66,253.33a2.14,2.14,0,0,1,2.22-2.19,1.63,1.63,0,0,1,1.82,1.64,2.14,2.14,0,0,1-2.22,2.19A1.64,1.64,0,0,1,354.66,253.33Zm3.16-.51a.89.89,0,0,0-1-.94,1.31,1.31,0,0,0-1.29,1.41.88.88,0,0,0,1,.93A1.3,1.3,0,0,0,357.82,252.82Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.06,251.14l-.16.83-.21,0a1.22,1.22,0,0,0-1.3,1.13l-.37,1.84h-.88l.74-3.74h.84l-.1.49A1.73,1.73,0,0,1,362.06,251.14Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.79,251.18h.87l-.74,3.74h-.87Zm.11-1.1a.56.56,0,0,1,.6-.56.48.48,0,0,1,.52.47.56.56,0,0,1-.59.58A.5.5,0,0,1,362.9,250.08Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.3,253.67c0,.06,0,.11,0,.16,0,.26.13.42.44.42a.88.88,0,0,0,.49-.15l.15.65a1.65,1.65,0,0,1-.9.22,1,1,0,0,1-1.07-1,1.5,1.5,0,0,1,0-.29l.35-1.77h-.6l.14-.7h.6l.17-.85H366l-.18.85h1l-.14.7h-1Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.78,251.18h.88l-.75,3.74H367Zm.11-1.1a.56.56,0,0,1,.6-.56.48.48,0,0,1,.52.47.55.55,0,0,1-.59.58A.5.5,0,0,1,367.89,250.08Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.92,253.31h-3c0,.6.36.92,1.08.92a1.55,1.55,0,0,0,1.08-.39l.36.61a2.31,2.31,0,0,1-1.53.52,1.63,1.63,0,0,1-1.84-1.64,2.1,2.1,0,0,1,2.15-2.19,1.57,1.57,0,0,1,1.73,1.64A2.2,2.2,0,0,1,372.92,253.31Zm-2.89-.58h2.14a.85.85,0,0,0-1-.89A1.18,1.18,0,0,0,370,252.73Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.09,254.57l.37-.68a2.32,2.32,0,0,0,1.3.37c.57,0,.85-.17.85-.45,0-.62-2-.14-2-1.41,0-.78.72-1.26,1.78-1.26a2.72,2.72,0,0,1,1.35.32l-.32.68a2.12,2.12,0,0,0-1.11-.29c-.57,0-.84.19-.84.45,0,.65,2,.16,2,1.41,0,.82-.74,1.26-1.79,1.26A2.9,2.9,0,0,1,373.09,254.57Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.64,142.58h-3.28l-1,1.85h-1.29l4.24-8h1.2l1.63,8H184Zm-.23-1.16-.66-3.51-1.8,3.51Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.64,138.34l-1,6.09h-1.11l.12-.67a2.21,2.21,0,0,1-1.69.75c-1.07,0-1.8-.73-1.8-2.07a4.76,4.76,0,0,1,.06-.72l.55-3.38h1.17l-.55,3.34a2.63,2.63,0,0,0,0,.47c0,.71.33,1.1,1,1.1.83,0,1.42-.57,1.61-1.75l.53-3.16Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.11,138.34l-.84,5.16c-.38,2.27-1.39,3.22-3.08,3.22a3.3,3.3,0,0,1-2.33-.83l.6-1.07a2.52,2.52,0,0,0,1.8.68c1.09,0,1.62-.59,1.8-1.76l.05-.29a2.19,2.19,0,0,1-1.63.7,2.24,2.24,0,0,1-2.23-2.51c0-1.9,1.18-3.37,2.83-3.37a1.83,1.83,0,0,1,1.76,1.07l.16-1Zm-1.66,2.53a1.25,1.25,0,0,0-1.31-1.39,1.86,1.86,0,0,0-1.72,2.08,1.26,1.26,0,0,0,1.32,1.39A1.85,1.85,0,0,0,196.45,140.87Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.47,138.34l-1,6.09h-1.11l.11-.67a2.18,2.18,0,0,1-1.69.75c-1.07,0-1.79-.73-1.79-2.07a3.74,3.74,0,0,1,.06-.72l.55-3.38h1.17l-.55,3.34a2.63,2.63,0,0,0,0,.47c0,.71.32,1.1,1,1.1.83,0,1.41-.57,1.61-1.75l.52-3.16Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.6,143.85l.49-1.1a2.7,2.7,0,0,0,1.73.6c.77,0,1.13-.28,1.13-.73,0-1-2.7-.23-2.7-2.3a2.09,2.09,0,0,1,2.37-2,3.06,3.06,0,0,1,1.79.53l-.43,1.09a2.4,2.4,0,0,0-1.47-.47c-.76,0-1.12.32-1.12.74,0,1.05,2.7.27,2.7,2.3,0,1.33-1,2-2.39,2A3.34,3.34,0,0,1,204.6,143.85Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.45,142.39a2.46,2.46,0,0,0,0,.26c0,.42.18.68.59.68a1,1,0,0,0,.65-.24l.2,1a1.9,1.9,0,0,1-1.2.37,1.44,1.44,0,0,1-1.43-1.63,2.74,2.74,0,0,1,0-.48l.48-2.87H210l.18-1.14h.81l.23-1.39h1.16l-.23,1.39h1.34l-.18,1.14h-1.35Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.11,253.44l-.3,1.49h2.37l-.15.77h-2.37l-.38,1.88h-.91l1-4.9h3.58l-.15.76Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.6,253.8l-.16.83-.22,0a1.23,1.23,0,0,0-1.3,1.13l-.37,1.84h-.87l.74-3.74h.83l-.1.48A1.79,1.79,0,0,1,151.6,253.8Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.32,253.84h.88l-.74,3.74h-.88Zm.12-1.11a.55.55,0,0,1,.59-.56.49.49,0,0,1,.53.47.56.56,0,0,1-.6.58A.49.49,0,0,1,152.44,252.73Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.3,252.38l-1,5.2h-.83l.07-.39a1.76,1.76,0,0,1-1.21.44,1.56,1.56,0,0,1-1.64-1.65,2.08,2.08,0,0,1,2.1-2.18,1.4,1.4,0,0,1,1.27.58l.4-2Zm-1.5,3.1a.89.89,0,0,0-1-.94,1.29,1.29,0,0,0-1.28,1.4.89.89,0,0,0,1,.94A1.3,1.3,0,0,0,156.8,255.48Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.81,253.84l-.74,3.74h-.83l.07-.39a1.79,1.79,0,0,1-1.22.44,1.57,1.57,0,0,1-1.64-1.65,2.08,2.08,0,0,1,2.11-2.18,1.39,1.39,0,0,1,1.27.59l.11-.55Zm-1.2,1.64a.89.89,0,0,0-1-.94,1.3,1.3,0,0,0-1.29,1.4.89.89,0,0,0,1,.94A1.3,1.3,0,0,0,161.61,255.48Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.47,253.84l-2.58,4.07c-.52.82-.93,1.08-1.58,1.08a1.52,1.52,0,0,1-1-.33l.44-.64a.87.87,0,0,0,.61.24c.3,0,.5-.14.74-.51l.12-.18-.89-3.73h.88l.63,2.77,1.73-2.77Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168,257a1,1,0,0,1-.2.54l-.65,1.09h-.56l.51-1.1a.53.53,0,0,1-.25-.46.59.59,0,0,1,.61-.61A.52.52,0,0,1,168,257Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.08,252.68l-1,4.9h-.91l.82-4.14h-1l.16-.76Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.32,256.07c0,1-.85,1.58-2.09,1.58s-1.91-.53-1.91-1.36a1.4,1.4,0,0,1,1.05-1.37,1,1,0,0,1-.44-.85c0-.91.79-1.46,1.9-1.46s1.76.48,1.76,1.25a1.26,1.26,0,0,1-.84,1.22A1.11,1.11,0,0,1,177.32,256.07Zm-.92,0c0-.44-.38-.72-1-.72s-1.15.33-1.15.85.4.72,1,.72S176.4,256.61,176.4,256.08Zm-1.56-2c0,.38.32.62.87.62s1-.29,1-.74-.35-.64-.88-.64S174.84,253.6,174.84,254.08Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.37,256.44H180.9l-.7,1.14h-1l3.19-4.9h.9l1.22,4.9h-.9Zm-.17-.71-.5-2.16-1.35,2.16Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.38,253.84l-.75,3.74h-.84l.09-.41a1.87,1.87,0,0,1-1.27.46,1.21,1.21,0,0,1-1.35-1.27,1.82,1.82,0,0,1,.05-.45l.41-2.07h.88l-.42,2a1.59,1.59,0,0,0,0,.29c0,.43.25.68.75.68a1.18,1.18,0,0,0,1.21-1.08l.39-1.94Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.23,253.84,193.6,257a2.13,2.13,0,0,1-2.31,2,2.85,2.85,0,0,1-1.76-.51l.46-.66a2.13,2.13,0,0,0,1.35.42,1.2,1.2,0,0,0,1.35-1.08l0-.18a1.86,1.86,0,0,1-1.23.43,1.52,1.52,0,0,1-1.67-1.55A2,2,0,0,1,192,253.8a1.4,1.4,0,0,1,1.32.66l.12-.62ZM193,255.39c0-.52-.36-.85-1-.85a1.23,1.23,0,0,0-1.29,1.27c0,.53.37.86,1,.86A1.23,1.23,0,0,0,193,255.39Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199,253.84l-.75,3.74h-.83l.08-.41a1.84,1.84,0,0,1-1.27.46,1.21,1.21,0,0,1-1.35-1.27,2.48,2.48,0,0,1,.05-.45l.41-2.07h.88l-.41,2a1.59,1.59,0,0,0,0,.29c0,.43.24.68.74.68a1.17,1.17,0,0,0,1.21-1.08l.4-1.94Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.1,257.22l.36-.67a2.35,2.35,0,0,0,1.3.36c.58,0,.85-.16.85-.44,0-.62-2-.14-2-1.41,0-.79.71-1.26,1.78-1.26a2.68,2.68,0,0,1,1.34.32l-.32.67a2.1,2.1,0,0,0-1.11-.29c-.57,0-.84.2-.84.46,0,.64,2,.16,2,1.41,0,.82-.75,1.26-1.8,1.26A2.84,2.84,0,0,1,199.1,257.22Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.23,256.33c0,.05,0,.11,0,.16,0,.26.13.42.44.42a.86.86,0,0,0,.49-.15l.16.64a1.71,1.71,0,0,1-.91.23,1,1,0,0,1-1.07-1,1.69,1.69,0,0,1,0-.3l.36-1.76h-.61l.14-.7h.61L204,253h.88l-.17.86h1l-.14.7h-1Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,98.69l.39-.71a2.58,2.58,0,0,0,1.6.53c.71,0,1.17-.26,1.17-.69,0-.91-2.47-.44-2.47-2,0-1,.87-1.59,2.14-1.59a3,3,0,0,1,1.63.42l-.35.72a2.38,2.38,0,0,0-1.33-.38c-.75,0-1.19.3-1.19.73,0,.92,2.48.47,2.48,2,0,1-.88,1.59-2.17,1.59A3.13,3.13,0,0,1,302,98.69Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311,95.46l-.75,3.74h-.84l.09-.42a1.83,1.83,0,0,1-1.27.46A1.2,1.2,0,0,1,306.84,98a1.82,1.82,0,0,1,.05-.45l.41-2.07h.88l-.42,2.05a1.41,1.41,0,0,0,0,.28c0,.44.25.68.75.68a1.18,1.18,0,0,0,1.21-1.07l.39-1.94Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.5,96.67a2.48,2.48,0,0,1-.05.45L315,99.2h-.88l.41-2.06a1.49,1.49,0,0,0,0-.28c0-.44-.24-.68-.75-.68a1.19,1.19,0,0,0-1.23,1.08l-.39,1.94h-.88l.75-3.74h.83l-.09.41a1.91,1.91,0,0,1,1.29-.46A1.21,1.21,0,0,1,315.5,96.67Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.88,94l-1,5.2H319l.07-.39a1.8,1.8,0,0,1-1.21.43,1.56,1.56,0,0,1-1.64-1.64,2.08,2.08,0,0,1,2.1-2.19,1.42,1.42,0,0,1,1.27.58l.4-2Zm-1.5,3.09a.88.88,0,0,0-1-.93,1.29,1.29,0,0,0-1.28,1.4.88.88,0,0,0,1,.94A1.3,1.3,0,0,0,319.38,97.09Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.39,95.46l-.74,3.74h-.84l.08-.39a1.78,1.78,0,0,1-1.22.43A1.56,1.56,0,0,1,321,97.6a2.09,2.09,0,0,1,2.11-2.19,1.4,1.4,0,0,1,1.27.6l.11-.55Zm-1.2,1.63a.88.88,0,0,0-1-.93,1.3,1.3,0,0,0-1.29,1.4.89.89,0,0,0,1,.94A1.31,1.31,0,0,0,324.19,97.09Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.05,95.46l-2.58,4.06c-.52.82-.93,1.08-1.58,1.08a1.47,1.47,0,0,1-1-.33l.44-.63a.86.86,0,0,0,.61.23c.3,0,.5-.14.74-.51l.12-.18-.89-3.72h.88l.63,2.77,1.73-2.77Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.57,98.63a1,1,0,0,1-.2.54l-.65,1.08h-.56l.5-1.09a.57.57,0,0,1-.24-.46.6.6,0,0,1,.61-.62A.53.53,0,0,1,330.57,98.63Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.43,98.42h2.26l-.16.78h-3.61l.12-.61,2.31-1.83c.61-.49.79-.78.79-1.14s-.27-.62-.84-.62a1.58,1.58,0,0,0-1.16.53l-.62-.49a2.46,2.46,0,0,1,1.91-.82c1,0,1.64.53,1.64,1.28,0,.57-.26,1.06-1.11,1.73Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.46,97.44c0-1.74,1-3.22,2.51-3.22a1.63,1.63,0,0,1,1.71,1.83c0,1.74-1,3.22-2.51,3.22A1.63,1.63,0,0,1,337.46,97.44Zm3.3-1.37c0-.71-.33-1.06-.87-1.06-1,0-1.52,1.38-1.52,2.41,0,.7.33,1,.88,1C340.23,98.47,340.76,97.1,340.76,96.07Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.47,98.06H345l-.71,1.14h-1l3.18-4.91h.91l1.22,4.91h-.91Zm-.16-.71-.5-2.16-1.35,2.16Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.48,95.46l-.75,3.74h-.83l.08-.42a1.79,1.79,0,0,1-1.27.46A1.21,1.21,0,0,1,349.36,98a2.48,2.48,0,0,1,.05-.45l.41-2.07h.88l-.41,2.05a1.41,1.41,0,0,0,0,.28c0,.44.24.68.74.68a1.17,1.17,0,0,0,1.21-1.07l.39-1.94Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.34,95.46l-.64,3.17a2.12,2.12,0,0,1-2.31,2,2.78,2.78,0,0,1-1.75-.51l.45-.66a2.1,2.1,0,0,0,1.36.42,1.19,1.19,0,0,0,1.35-1.08l0-.18a1.79,1.79,0,0,1-1.22.44,1.53,1.53,0,0,1-1.68-1.55,2.05,2.05,0,0,1,2.13-2.07,1.42,1.42,0,0,1,1.32.66l.12-.61ZM357.09,97c0-.53-.36-.85-1-.85a1.23,1.23,0,0,0-1.28,1.27c0,.53.37.85,1,.85A1.23,1.23,0,0,0,357.09,97Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.11,95.46l-.75,3.74h-.84l.09-.42a1.83,1.83,0,0,1-1.27.46A1.2,1.2,0,0,1,359,98a1.82,1.82,0,0,1,.05-.45l.41-2.07h.88l-.42,2.05a1.41,1.41,0,0,0,0,.28c0,.44.25.68.75.68a1.18,1.18,0,0,0,1.21-1.07l.39-1.94Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.2,98.84l.37-.67a2.41,2.41,0,0,0,1.3.36c.57,0,.85-.17.85-.45,0-.61-2-.14-2-1.41,0-.78.72-1.26,1.78-1.26a2.64,2.64,0,0,1,1.35.33l-.33.67a2.09,2.09,0,0,0-1.1-.29c-.57,0-.84.2-.84.46,0,.64,2,.16,2,1.4,0,.82-.74,1.26-1.79,1.26A2.9,2.9,0,0,1,363.2,98.84Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.34,97.94a.92.92,0,0,0,0,.16c0,.26.13.42.44.42a1,1,0,0,0,.49-.14l.15.64a1.65,1.65,0,0,1-.9.22,1,1,0,0,1-1.07-1,1.46,1.46,0,0,1,0-.29l.36-1.77h-.61l.14-.7H368l.17-.85H369l-.18.85h1l-.14.7h-1Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.28,160.78l-2.59,4.91h-1l-.49-3.6-2,3.6h-1l-.65-4.91h.91l.48,3.73,2-3.73h.85l.48,3.77,2-3.77Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.54,164.08h-3c0,.59.35.91,1.08.91a1.59,1.59,0,0,0,1.07-.38l.37.61a2.32,2.32,0,0,1-1.54.52,1.65,1.65,0,0,1-1.84-1.65,2.1,2.1,0,0,1,2.16-2.19,1.57,1.57,0,0,1,1.72,1.64A3.1,3.1,0,0,1,306.54,164.08Zm-2.9-.59h2.15a.85.85,0,0,0-1-.88A1.18,1.18,0,0,0,303.64,163.49Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.7,160.49l-1,5.2h-.84l.08-.39a1.83,1.83,0,0,1-1.21.44,1.56,1.56,0,0,1-1.65-1.65,2.09,2.09,0,0,1,2.1-2.19,1.43,1.43,0,0,1,1.28.59l.4-2Zm-1.5,3.1a.87.87,0,0,0-1-.94,1.29,1.29,0,0,0-1.29,1.4.89.89,0,0,0,1,.94A1.3,1.3,0,0,0,310.2,163.59Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316,163.17a3.71,3.71,0,0,1-.05.44l-.42,2.08h-.87l.4-2.06a1,1,0,0,0,0-.28c0-.44-.24-.68-.75-.68a1.18,1.18,0,0,0-1.22,1.08l-.4,1.94h-.87l.74-3.74h.84l-.09.41a1.87,1.87,0,0,1,1.29-.46A1.22,1.22,0,0,1,316,163.17Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.51,164.08h-3c0,.59.36.91,1.08.91a1.61,1.61,0,0,0,1.08-.38l.36.61a2.31,2.31,0,0,1-1.53.52,1.65,1.65,0,0,1-1.85-1.65,2.1,2.1,0,0,1,2.16-2.19,1.57,1.57,0,0,1,1.72,1.64A3.1,3.1,0,0,1,320.51,164.08Zm-2.89-.59h2.14a.84.84,0,0,0-1-.88A1.17,1.17,0,0,0,317.62,163.49Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.68,165.33l.36-.67a2.47,2.47,0,0,0,1.31.36c.57,0,.85-.17.85-.45,0-.61-2-.14-2-1.4,0-.79.72-1.27,1.78-1.27a2.58,2.58,0,0,1,1.34.33l-.32.67a2.09,2.09,0,0,0-1.1-.29c-.57,0-.84.2-.84.46,0,.64,2,.16,2,1.41,0,.81-.74,1.26-1.79,1.26A2.9,2.9,0,0,1,320.68,165.33Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.28,160.49l-1,5.2h-.83l.08-.39a1.84,1.84,0,0,1-1.22.44,1.56,1.56,0,0,1-1.64-1.65,2.09,2.09,0,0,1,2.1-2.19,1.4,1.4,0,0,1,1.27.59l.4-2Zm-1.5,3.1a.88.88,0,0,0-1-.94,1.29,1.29,0,0,0-1.28,1.4.89.89,0,0,0,1,.94A1.3,1.3,0,0,0,327.78,163.59Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.79,162l-.74,3.74h-.83l.08-.39a1.8,1.8,0,0,1-1.22.44,1.57,1.57,0,0,1-1.65-1.65,2.09,2.09,0,0,1,2.11-2.19,1.4,1.4,0,0,1,1.27.6l.11-.55Zm-1.2,1.64a.88.88,0,0,0-1-.94,1.3,1.3,0,0,0-1.29,1.4.89.89,0,0,0,1,.94A1.3,1.3,0,0,0,332.59,163.59Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.45,162,335.87,166c-.52.82-.92,1.07-1.57,1.07a1.5,1.5,0,0,1-1-.32l.43-.64a.89.89,0,0,0,.62.24c.29,0,.49-.14.73-.52l.12-.18-.88-3.72h.87l.63,2.77,1.73-2.77Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339,165.12a1,1,0,0,1-.2.54l-.65,1.08h-.56l.51-1.09a.54.54,0,0,1-.25-.46.61.61,0,0,1,.61-.62A.53.53,0,0,1,339,165.12Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.84,164.92h2.25l-.16.77h-3.61l.12-.61,2.31-1.83c.61-.48.8-.78.8-1.13s-.28-.63-.84-.63a1.58,1.58,0,0,0-1.17.53l-.61-.49a2.45,2.45,0,0,1,1.9-.82c1,0,1.64.54,1.64,1.28,0,.57-.25,1.06-1.11,1.73Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.6,161.39l-1.49,1.44a1.22,1.22,0,0,1,1.13,1.25c0,1-.88,1.68-2.17,1.68a2.57,2.57,0,0,1-1.76-.59l.46-.69a1.93,1.93,0,0,0,1.36.49c.76,0,1.19-.32,1.19-.84s-.3-.64-.94-.64h-.44l.12-.62,1.37-1.32h-2.21l.16-.77h3.33Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.27,164.55H352.8l-.7,1.14h-1l3.19-4.91h.9l1.22,4.91h-.9Zm-.17-.71-.5-2.16-1.35,2.16Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.28,162l-.75,3.74h-.84l.09-.42a1.84,1.84,0,0,1-1.27.47,1.21,1.21,0,0,1-1.35-1.27,1.82,1.82,0,0,1,0-.45l.41-2.07h.88l-.42,2.05a1.5,1.5,0,0,0,0,.29c0,.43.25.68.75.68a1.18,1.18,0,0,0,1.21-1.08l.39-1.94Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.13,162l-.63,3.17a2.13,2.13,0,0,1-2.31,2,2.79,2.79,0,0,1-1.76-.51l.46-.65a2.13,2.13,0,0,0,1.35.42,1.2,1.2,0,0,0,1.35-1.08l0-.19a1.81,1.81,0,0,1-1.23.44,1.52,1.52,0,0,1-1.67-1.55,2,2,0,0,1,2.12-2.07,1.42,1.42,0,0,1,1.32.66l.12-.61Zm-1.25,1.55c0-.52-.36-.85-1-.85a1.23,1.23,0,0,0-1.29,1.27c0,.53.37.86,1,.86A1.23,1.23,0,0,0,364.88,163.5Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.9,162l-.75,3.74h-.83l.08-.42a1.8,1.8,0,0,1-1.27.47,1.21,1.21,0,0,1-1.35-1.27,2.48,2.48,0,0,1,.05-.45l.41-2.07h.88l-.41,2.05a1.5,1.5,0,0,0,0,.29c0,.43.24.68.74.68a1.17,1.17,0,0,0,1.21-1.08L370,162Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371,165.33l.36-.67a2.43,2.43,0,0,0,1.3.36c.58,0,.85-.17.85-.45,0-.61-2-.14-2-1.4,0-.79.71-1.27,1.78-1.27a2.61,2.61,0,0,1,1.34.33l-.32.67a2.1,2.1,0,0,0-1.11-.29c-.57,0-.84.2-.84.46,0,.64,2,.16,2,1.41,0,.81-.75,1.26-1.8,1.26A2.84,2.84,0,0,1,371,165.33Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.13,164.43c0,.06,0,.12,0,.16,0,.26.13.42.44.42a.85.85,0,0,0,.49-.14l.16.64a1.71,1.71,0,0,1-.91.23,1,1,0,0,1-1.07-1,1.59,1.59,0,0,1,0-.29l.36-1.76H375l.14-.7h.61l.16-.86h.88l-.17.86h1l-.14.7h-1Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.7,
    y: 273.16,
    width: 77.3,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.7,
    y: 281.53,
    width: 56.66,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.7,
    y: 289.91,
    width: 91.25,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.74,267.71a3.11,3.11,0,1,1,3.11-3.11A3.1,3.1,0,0,1,338.74,267.71Zm0-5.21a2.11,2.11,0,1,0,2.11,2.1A2.1,2.1,0,0,0,338.74,262.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.74,290.59a3.11,3.11,0,1,1,3.11-3.1A3.1,3.1,0,0,1,338.74,290.59Zm0-5.21a2.11,2.11,0,1,0,2.11,2.11A2.11,2.11,0,0,0,338.74,285.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.74,276.4a3.11,3.11,0,1,1,3.1-3.11A3.11,3.11,0,0,1,109.74,276.4Zm0-5.21a2.11,2.11,0,1,0,2.1,2.1A2.11,2.11,0,0,0,109.74,271.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.74,284.9a3.11,3.11,0,1,1,3.1-3.11A3.11,3.11,0,0,1,109.74,284.9Zm0-5.22a2.11,2.11,0,1,0,2.1,2.11A2.12,2.12,0,0,0,109.74,279.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.74,293.39a3.11,3.11,0,1,1,3.1-3.1A3.1,3.1,0,0,1,109.74,293.39Zm0-5.21a2.11,2.11,0,1,0,2.1,2.11A2.12,2.12,0,0,0,109.74,288.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.74,301.89a3.11,3.11,0,1,1,3.1-3.11A3.11,3.11,0,0,1,109.74,301.89Zm0-5.21a2.11,2.11,0,1,0,2.1,2.1A2.11,2.11,0,0,0,109.74,296.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.46,
    y: 111.96,
    width: 63.32,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.46,
    y: 120.33,
    width: 31.66,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.46,
    y: 128.71,
    width: 59.6,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.46,
    y: 137.09,
    width: 73.26,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.49,115.08a3.11,3.11,0,1,1,3.11-3.1A3.1,3.1,0,0,1,268.49,115.08Zm0-5.21A2.11,2.11,0,1,0,270.6,112,2.1,2.1,0,0,0,268.49,109.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.49,123.58a3.11,3.11,0,1,1,3.11-3.11A3.1,3.1,0,0,1,268.49,123.58Zm0-5.21a2.11,2.11,0,1,0,2.11,2.1A2.1,2.1,0,0,0,268.49,118.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.49,132.08A3.11,3.11,0,1,1,271.6,129,3.11,3.11,0,0,1,268.49,132.08Zm0-5.22A2.11,2.11,0,1,0,270.6,129,2.11,2.11,0,0,0,268.49,126.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.49,140.57a3.11,3.11,0,1,1,3.11-3.1A3.1,3.1,0,0,1,268.49,140.57Zm0-5.21a2.11,2.11,0,1,0,2.11,2.11A2.11,2.11,0,0,0,268.49,135.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.49,149.07A3.11,3.11,0,1,1,271.6,146,3.1,3.1,0,0,1,268.49,149.07Zm0-5.21a2.11,2.11,0,1,0,2.11,2.1A2.1,2.1,0,0,0,268.49,143.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.46,
    y: 179.82,
    width: 72.06,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.46,
    y: 188.19,
    width: 82.57,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.46,
    y: 196.57,
    width: 57.88,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.49,
    y: 264.1,
    width: 36.01,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.49,
    y: 275.27,
    width: 48.26,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.49,
    y: 286.44,
    width: 36.01,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.49,
    y: 297.61,
    width: 38.78,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.88,
    y: 264.1,
    width: 33.26,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.88,
    y: 275.27,
    width: 22.6,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.88,
    y: 286.44,
    width: 25.01,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.88,
    y: 297.61,
    width: 25.14,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.49,182.94a3.11,3.11,0,1,1,3.11-3.1A3.1,3.1,0,0,1,268.49,182.94Zm0-5.21a2.11,2.11,0,1,0,2.11,2.11A2.1,2.1,0,0,0,268.49,177.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.49,191.44a3.11,3.11,0,1,1,3.11-3.11A3.1,3.1,0,0,1,268.49,191.44Zm0-5.21a2.11,2.11,0,1,0,2.11,2.1A2.1,2.1,0,0,0,268.49,186.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.49,199.94a3.11,3.11,0,1,1,3.11-3.11A3.11,3.11,0,0,1,268.49,199.94Zm0-5.22a2.11,2.11,0,1,0,2.11,2.11A2.11,2.11,0,0,0,268.49,194.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.69,209.53a3.11,3.11,0,1,1,3.11-3.11A3.1,3.1,0,0,1,268.69,209.53Zm0-5.21a2.11,2.11,0,1,0,2.11,2.1A2.1,2.1,0,0,0,268.69,204.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "258.95 311.32 258.95 333.7 269.85 326.57 269.85 311.32 258.95 311.32",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.79,77.09l3.11-5.22a5.42,5.42,0,0,1,3.49-2.52l5.72-1.28a5.42,5.42,0,0,1,5.28,1.72c2.52,2.88,6.35,7.3,6.09,7.3H258.6L258,75.64a5.44,5.44,0,0,0-5-3.42h-2.63Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.79,306.6a.5.5,0,0,1-.5-.5V102a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5V306.1A.5.5,0,0,1,244.79,306.6Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.79,96a.51.51,0,0,1-.5-.5V86.35a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v9.11A.5.5,0,0,1,244.79,96Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.11 276.53 253.93 273.35 254.63 272.64 257.1 275.1 262 270.04 262.72 270.73 257.11 276.53",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.11 299.61 253.93 296.42 254.63 295.72 257.1 298.18 262 293.12 262.72 293.81 257.11 299.61",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.87,233.29a.5.5,0,0,1-.2-1,38.36,38.36,0,0,1,12.27-3.11.5.5,0,0,1,.54.45.49.49,0,0,1-.45.54,37.5,37.5,0,0,0-12,3A.71.71,0,0,1,96.87,233.29Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.16,244.9a.48.48,0,0,1-.2,0,.49.49,0,0,1-.25-.66,38.33,38.33,0,0,0,3.13-11.65.5.5,0,1,1,1,.1,39.43,39.43,0,0,1-3.22,12A.51.51,0,0,1,99.16,244.9Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.24,243a2.07,2.07,0,0,1-.5-.06,2.27,2.27,0,0,1-1.5-1.17,3.3,3.3,0,0,1-.21-2.61,7.31,7.31,0,0,1,2.64-3.09.56.56,0,0,0,.62-.62,2,2,0,0,1,2,0,2.84,2.84,0,0,1,1.51,2.22,5.21,5.21,0,0,1-1.8,3.83A4,4,0,0,1,107.24,243Zm1.23-6.63a.5.5,0,0,1-.18.48,6.65,6.65,0,0,0-2.32,2.64,2.3,2.3,0,0,0,.15,1.8,1.28,1.28,0,0,0,.84.67c.65.15,1.43-.24,2.3-1.16a4.29,4.29,0,0,0,1.53-3.07,1.86,1.86,0,0,0-1-1.41,1.07,1.07,0,0,0-1,0A.47.47,0,0,1,108.47,236.36Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.41,252.11a2.12,2.12,0,0,1-.5-.05,2.31,2.31,0,0,1-1.49-1.17,3.3,3.3,0,0,1-.22-2.61,7.38,7.38,0,0,1,2.64-3.09.52.52,0,0,1,.39-.1.5.5,0,0,1,.23-.52,2,2,0,0,1,2,0,2.84,2.84,0,0,1,1.51,2.23,5.17,5.17,0,0,1-1.8,3.83A4,4,0,0,1,123.41,252.11Zm1.23-6.62a.48.48,0,0,1-.18.48,6.58,6.58,0,0,0-2.32,2.64,2.3,2.3,0,0,0,.15,1.8,1.28,1.28,0,0,0,.84.67c.65.15,1.43-.24,2.31-1.16a4.28,4.28,0,0,0,1.52-3.07,1.86,1.86,0,0,0-1-1.41,1,1,0,0,0-1,0A.45.45,0,0,1,124.64,245.49Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.4,252.91a.5.5,0,0,1-.42-.23.51.51,0,0,1,0-.57A30.39,30.39,0,0,0,114.8,242a.52.52,0,0,1,.29-.34c2.79-1.17,5-1,6.08.55a3.5,3.5,0,0,1,.23,3.48,7.35,7.35,0,0,1-2.13,2.55,21.65,21.65,0,0,1-8.77,4.67Zm5.3-10.44a30.59,30.59,0,0,1-4.11,9.09,22.13,22.13,0,0,0,7-4.11,6.43,6.43,0,0,0,1.86-2.19,2.52,2.52,0,0,0-.12-2.47C119.31,241.36,117.08,241.93,115.7,242.47Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103,257.52c-1.33,0-2.21-.47-2.49-1.35a2.82,2.82,0,0,1,.63-2.31l2.38-3.58c.74-1.11.93-1.9.6-2.4s-.86-.6-1.82-.6h0a17.52,17.52,0,0,0-6,1.09.49.49,0,0,1-.64-.29.5.5,0,0,1,.29-.65,18.79,18.79,0,0,1,6.38-1.15,3.15,3.15,0,0,1,2.67,1c.87,1.3-.23,3-.6,3.51l-2.38,3.58c-.31.48-.64,1-.5,1.46.24.77,1.72.67,2.16.62a186.56,186.56,0,0,0,23.36-4.11.5.5,0,0,1,.6.37.49.49,0,0,1-.36.6,186.49,186.49,0,0,1-23.49,4.13A6.34,6.34,0,0,1,103,257.52Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.49,259.47a.5.5,0,0,1-.49-.4.51.51,0,0,1,.39-.59l19.38-4a.5.5,0,1,1,.2,1l-19.38,3.95Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.16,236.81a.51.51,0,0,1-.47-.34,59.2,59.2,0,0,1-2.49-14.1,49.91,49.91,0,0,0-3.11,12.27.5.5,0,0,1-1-.12,50.56,50.56,0,0,1,4-14.43.49.49,0,0,1,.54-.29.5.5,0,0,1,.42.45,75.44,75.44,0,0,0,2,14.07,63.57,63.57,0,0,1,5.86-15.71.5.5,0,0,1,.67-.21.5.5,0,0,1,.21.68,62.56,62.56,0,0,0-6.16,17.33.5.5,0,0,1-.46.4Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.78,232.8a2.55,2.55,0,0,1-1-.2,2.82,2.82,0,0,1-1.2-3.57,5.87,5.87,0,0,1,1.64-2.23,4.87,4.87,0,0,1,.52-.76,3.32,3.32,0,0,1,2.2-1.29,3,3,0,0,1,3,2.11,4,4,0,0,1-.71,3.56,6.38,6.38,0,0,1-2.89,2A4.37,4.37,0,0,1,318.78,232.8Zm-.95-4.06a4.25,4.25,0,0,0-.32.64,1.86,1.86,0,0,0,.68,2.3,2.37,2.37,0,0,0,1.81-.15,5.44,5.44,0,0,0,2.45-1.71,3,3,0,0,0,.56-2.66,2,2,0,0,0-2-1.42,2.31,2.31,0,0,0-1.37.75.5.5,0,0,1-.15.5l-.5.44c-.19.34-.36.7-.52,1.06a.49.49,0,0,1-.66.25Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.56,225a.5.5,0,0,1-.06-1,69.25,69.25,0,0,1,10.28-.45.5.5,0,0,1,.48.52.48.48,0,0,1-.51.48,68.58,68.58,0,0,0-10.13.44Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.89,234.52h-.06a.5.5,0,0,1-.43-.56,24.77,24.77,0,0,1,2.82-8.7.5.5,0,0,1,.88.48,23.48,23.48,0,0,0-2.71,8.35A.5.5,0,0,1,325.89,234.52Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.81,233.29a3.11,3.11,0,0,1-1.95-.62,3.53,3.53,0,0,1-1.11-3.45,4.6,4.6,0,0,1,1.61-2.77,3.77,3.77,0,0,1,3.18-.71,2.23,2.23,0,0,1,1.78,2.49.49.49,0,0,1-.4.37l-4.64.82a.5.5,0,0,1-.51-.21,1.62,1.62,0,0,1,0,.19,2.59,2.59,0,0,0,.74,2.48,2.42,2.42,0,0,0,2,.33,8.39,8.39,0,0,0,2.19-.93.5.5,0,1,1,.48.88,9.52,9.52,0,0,1-2.46,1A4.47,4.47,0,0,1,332.81,233.29Zm.88-6.66a2.84,2.84,0,0,0-1.71.61,3.32,3.32,0,0,0-.94,1.21h.06l4.26-.75a1.48,1.48,0,0,0-1.07-1A2.35,2.35,0,0,0,333.69,226.63Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.54,234.67a2.49,2.49,0,0,1-2.37-1.42.5.5,0,0,1,.92-.38,1.67,1.67,0,0,0,2,.73,1.78,1.78,0,0,0,1.33-1.6c0-.83-1-1.79-1.95-2.34a2.55,2.55,0,0,1-1.19-2.61,2.38,2.38,0,0,1,2.17-1.9,2.24,2.24,0,0,1,2.27,1.8,1.91,1.91,0,0,1-.18,1.21.5.5,0,1,1-.88-.47,1,1,0,0,0,.08-.57,1.28,1.28,0,0,0-1.24-1,1.36,1.36,0,0,0-1.23,1.09,1.53,1.53,0,0,0,.72,1.56c1.14.68,2.37,1.87,2.42,3.16a2.75,2.75,0,0,1-2,2.6A2.9,2.9,0,0,1,338.54,234.67Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.64,238.41a.5.5,0,0,1,0-1l27.88-2a.5.5,0,1,1,.07,1l-27.88,2Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.26,240.65a.5.5,0,0,1-.05-1l23.57-2.41a.5.5,0,0,1,.55.44.51.51,0,0,1-.45.55l-23.57,2.41Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.71,108.8a4.69,4.69,0,0,1-2-.41,4.52,4.52,0,0,1-2.6-4.16,5.41,5.41,0,0,1,2.22-3.9,15,15,0,0,1,3.84-2,.5.5,0,1,1,.37.93A14.2,14.2,0,0,0,99,101.11a4.46,4.46,0,0,0-1.84,3.17,3.46,3.46,0,0,0,2,3.2,4,4,0,0,0,3.88-.41,8.43,8.43,0,0,0,2.13-2.56,61.3,61.3,0,0,0,7-16.07.5.5,0,1,1,1,.27A62.63,62.63,0,0,1,106,105a9.24,9.24,0,0,1-2.41,2.85A5.11,5.11,0,0,1,100.71,108.8Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,111a4.64,4.64,0,0,1-1.24-.17,8.08,8.08,0,0,1-3.43-2.45,7.6,7.6,0,0,0-2.87-2.17.5.5,0,0,1-.33-.63.51.51,0,0,1,.63-.32,8.57,8.57,0,0,1,3.29,2.42,7.19,7.19,0,0,0,3,2.19c1.67.47,3.48-.45,4.71-1.31a10,10,0,0,0,3.54-4,5.54,5.54,0,0,0-.08-5,2.61,2.61,0,0,0-1.76-1.3,3.42,3.42,0,0,1-.84.13.48.48,0,0,1-.5-.39.49.49,0,0,1,.29-.57,2.37,2.37,0,0,1,.93-.18,2.65,2.65,0,0,0,.59-4.77,4.08,4.08,0,0,0-2.54-.47,6.41,6.41,0,0,0-3.81,1.6,4.61,4.61,0,0,0-1.51,3.65.5.5,0,1,1-1,.08,5.63,5.63,0,0,1,1.83-4.46,7.41,7.41,0,0,1,4.4-1.87,5.08,5.08,0,0,1,3.16.62,3.64,3.64,0,0,1,.23,6,4,4,0,0,1,1.39,1.4,6.48,6.48,0,0,1,.13,5.89,11,11,0,0,1-3.88,4.37A7.73,7.73,0,0,1,110,111Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.63,110.37h-.3a1.3,1.3,0,0,1-1.17-.86c-.77-2,2.13-7.39,3.94-9.27a.5.5,0,1,1,.72.7c-1.86,1.93-4.24,6.84-3.72,8.21a.3.3,0,0,0,.3.22c3.38.25,6-5.59,6.7-9.82a.49.49,0,0,1,.58-.41.51.51,0,0,1,.41.58C126.32,104.06,123.72,110.37,119.63,110.37Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.84,110a1.32,1.32,0,0,1-.42-.07c-.78-.25-1.17-1.11-1.07-2.36a29.67,29.67,0,0,1,.53-3.63.46.46,0,0,1-.23-.14.5.5,0,0,1,0-.71l.52-.47a28.88,28.88,0,0,1,5.66-11.06c1.14-1.37,2.37-1.87,3.38-1.36a.53.53,0,0,1,.27.53c-.83,4.92-4.39,8.72-8.42,12.42a27.43,27.43,0,0,0-.74,4.5c0,.57,0,1.22.38,1.33s.63-.14,1.09-.68a.49.49,0,0,1,.7,0,.48.48,0,0,1,0,.7A2.56,2.56,0,0,1,127.84,110Zm7.57-19c-.73,0-1.53.88-1.78,1.19a27.85,27.85,0,0,0-5,9.07c3.25-3.11,6-6.34,6.8-10.26Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.91,110.05a2.86,2.86,0,0,1-3.1-2.73c-.8.66-1.36,1.1-1.44,1.17-.25.26-1.15,1.2-2.15.81-.77-.29-1.11-1.18-.94-2.42a29.27,29.27,0,0,1,.73-3.59.57.57,0,0,1-.23-.16.5.5,0,0,1,.08-.7l.54-.45a29,29,0,0,1,6.27-10.72c1.21-1.31,2.47-1.73,3.45-1.17a.5.5,0,0,1,.24.55c-1.1,4.86-4.87,8.46-9.09,11.93a27.14,27.14,0,0,0-1,4.44c-.08.57,0,1.23.3,1.36s.64-.11,1.13-.62l2.09-1.7s0-.09,0-.13a10.6,10.6,0,0,1,1.74-5.81c1.26-1.66,3.77-2.75,5.79-1.71A1.31,1.31,0,0,1,143,99a1.43,1.43,0,0,1-.35,1.39,74.08,74.08,0,0,1-6.86,6.11,2.74,2.74,0,0,0,.55,2,2.78,2.78,0,0,0,2.4.47,6.65,6.65,0,0,0,4.22-2.73.5.5,0,0,1,.82.57,7.64,7.64,0,0,1-4.85,3.14A4.78,4.78,0,0,1,137.91,110.05ZM140.59,99a4.3,4.3,0,0,0-3.25,1.72,8.78,8.78,0,0,0-1.48,4.46,64.08,64.08,0,0,0,6-5.36c.22-.29.21-.38.21-.39a1.15,1.15,0,0,0-.19-.13A2.81,2.81,0,0,0,140.59,99Zm-.39-8.14a3.08,3.08,0,0,0-1.79,1.09,28,28,0,0,0-5.5,8.78c3.42-2.92,6.34-6,7.37-9.87Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.71,109.1a1.84,1.84,0,0,1-.88-.21,2.62,2.62,0,0,1-1.16-2.49,11.26,11.26,0,0,1,1.06-4.08,49.7,49.7,0,0,1,5.08-9.24.5.5,0,0,1,.7-.13.51.51,0,0,1,.12.7,48.85,48.85,0,0,0-5,9,10.45,10.45,0,0,0-1,3.72c0,.29,0,1.27.63,1.59a1.64,1.64,0,0,0,1.66-.46,8.64,8.64,0,0,0,.66-.69,6.18,6.18,0,0,1,1.11-1,.5.5,0,1,1,.57.81,6.17,6.17,0,0,0-.94.91,8.91,8.91,0,0,1-.74.77A3.07,3.07,0,0,1,144.71,109.1Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.59,99.18a.5.5,0,0,1-.05-1,31.23,31.23,0,0,0,6.63-1.36.51.51,0,0,1,.63.33.51.51,0,0,1-.33.63,33.25,33.25,0,0,1-6.83,1.39Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.47,125.68a3.32,3.32,0,0,1-2.79-1.84,8.92,8.92,0,0,1-.82-3.15.5.5,0,0,1,1-.13,7.7,7.7,0,0,0,.7,2.8,2.34,2.34,0,0,0,2,1.32c.94-.05,1.76-.9,2.53-2.6,1.16-2.58,2.17-5.29,3.14-7.92a83.35,83.35,0,0,1,5.23-12.07l-10.93,2.43c-.13,0-.21,0-.23.08a1.35,1.35,0,0,1,.05.2l.61,2.87a.5.5,0,0,1-1,.21l-.61-2.87a1.29,1.29,0,0,1,.09-1,1.27,1.27,0,0,1,.86-.51l12.05-2.68a.5.5,0,0,1,.51.2.48.48,0,0,1,0,.55,74.67,74.67,0,0,0-5.73,12.9c-1,2.64-2,5.37-3.17,8-.34.76-1.39,3.09-3.39,3.19Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.82,120.93a2,2,0,0,1-1.33-.45c-.47-.39-1-1.2-.64-2.83a12.1,12.1,0,0,1,1.33-3.66,1.93,1.93,0,0,1,.8-.85,1.13,1.13,0,0,1,.92,0,.92.92,0,0,1,.28.19,5.11,5.11,0,0,1,.41-.62,3,3,0,0,1,3.35-1.07,2.84,2.84,0,0,1,1.58,2.75,4.71,4.71,0,0,1-.78,2.3,28.44,28.44,0,0,0,3.87-3,.5.5,0,0,1,.75.64,11,11,0,0,0-1.35,4.19.94.94,0,0,0,0,.44c.11.21.66.12,1.09-.1a12,12,0,0,0,3.5-2.74.51.51,0,0,1,.71-.05.49.49,0,0,1,0,.7,12.93,12.93,0,0,1-3.79,3c-.86.44-2,.53-2.44-.33a1.72,1.72,0,0,1-.12-1,13.37,13.37,0,0,1,.56-2.54,29.78,29.78,0,0,1-4,2.63,6.09,6.09,0,0,1-.63.3,10.81,10.81,0,0,1-2.3,1.61A4.1,4.1,0,0,1,168.82,120.93Zm.67-6.88a.77.77,0,0,0-.44.43,10.93,10.93,0,0,0-1.22,3.36c-.12.64-.17,1.48.3,1.87s1.63.05,2.05-.17c.22-.12.44-.24.65-.37a1.93,1.93,0,0,1-1.37-.83,3.2,3.2,0,0,1-.13-2.59,14.65,14.65,0,0,1,.41-1.46A.49.49,0,0,1,169.49,114.05Zm3.55-1.61a2.28,2.28,0,0,0-1.66.88A6.77,6.77,0,0,0,170.3,116a2.32,2.32,0,0,0,0,1.78c.4.6,1.33.46,2.1.18a10.42,10.42,0,0,0,1.2-1.37,4.25,4.25,0,0,0,.92-2.26,1.86,1.86,0,0,0-1-1.78A1.3,1.3,0,0,0,173,112.44Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.38,121.45a2.27,2.27,0,0,1-1-.22c-.48-.1-.81-.6-.85-1.37a10.34,10.34,0,0,1,2.5-7.35.49.49,0,0,1,.7-.05.51.51,0,0,1,0,.71,9.37,9.37,0,0,0-2.25,6.63.77.77,0,0,0,.12.47l.16.06c1.27.61,3.77-1.09,7-7.65a1.1,1.1,0,0,1,.21-.4.5.5,0,0,1,.84.53l-.06.12a.88.88,0,0,0,.57.25,1.75,1.75,0,0,0,1.31-.71,4.12,4.12,0,0,0,.28-.31,4.44,4.44,0,0,1,1.33-1.13.52.52,0,0,1,.6.13.5.5,0,0,1,0,.61,13.16,13.16,0,0,0-2.27,5.49c-.06.57,0,1.46.54,1.56a1.27,1.27,0,0,0,.67-.16,6.24,6.24,0,0,0,3-2.86.49.49,0,0,1,.67-.22.49.49,0,0,1,.22.67,7.22,7.22,0,0,1-3.47,3.32,2.09,2.09,0,0,1-1.27.23c-1.16-.23-1.45-1.57-1.35-2.64a11,11,0,0,1,1-3.35,2.24,2.24,0,0,1-1.35.37,2.09,2.09,0,0,1-.94-.33C187.2,120.05,184.85,121.45,183.38,121.45Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.18,121.83a.93.93,0,0,1-.32,0c-.64-.2-.92-.92-.71-1.84A11.9,11.9,0,0,1,200.8,117c1-1.58,2.63-4,2.42-4.8a.17.17,0,0,0-.09-.12c-.5-.27-2.15.24-2.86.7a7.12,7.12,0,0,0-1.83,2.23c-.14.23-.28.45-.42.65a20.46,20.46,0,0,0-1,2.12c-.82,2-1.23,2.88-1.64,3.14a.5.5,0,1,1-.54-.84,18,18,0,0,0,1.26-2.68,17.36,17.36,0,0,1,1.05-2.29l.4-.63a7.89,7.89,0,0,1,2.13-2.53c.7-.46,2.82-1.33,3.88-.75a1.17,1.17,0,0,1,.59.76c.29,1.16-.87,3.05-2.55,5.59a13.84,13.84,0,0,0-1.52,2.58c-.08.38,0,.65,0,.67s.11,0,.31-.09a10.35,10.35,0,0,0,3-1.87.5.5,0,0,1,.7,0,.5.5,0,0,1,0,.71,11.55,11.55,0,0,1-3.24,2A1.83,1.83,0,0,1,200.18,121.83Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.75,121.47a1,1,0,0,1-.54-.17,1.91,1.91,0,0,1-.65-1.35l0-.26c-1.11,1-2.56,1.65-3.88,1a3.19,3.19,0,0,1-1.71-2.4,6.27,6.27,0,0,1,.27-2.76,8.65,8.65,0,0,1,3.82-5.34,2.37,2.37,0,0,1,3.5.75l0,0s0,0,0,0c1.07,2.18.63,5.14-1.13,7.59,0,.39.07.79.11,1.22a1.06,1.06,0,0,0,.23.62.47.47,0,0,1,.59.35.52.52,0,0,1-.37.61Zm-1.22-10.71a2.06,2.06,0,0,0-1,.31,7.7,7.7,0,0,0-3.4,4.77,5.14,5.14,0,0,0-.24,2.33,2.19,2.19,0,0,0,1.14,1.65c1.11.51,2.46-.36,3.35-1.48a13.09,13.09,0,0,1,1.12-7A1.27,1.27,0,0,0,209.53,110.76Zm1.53,1.89a11.08,11.08,0,0,0-.71,4.18A6.69,6.69,0,0,0,211.06,112.65Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.7,123.8a1.57,1.57,0,0,1-.87-.24c-.71-.44-.94-1.33-.69-2.64l.24-1.19c-1.43,1.28-2.74,2-3.67,1.7a.51.51,0,0,1-.32-.63.5.5,0,0,1,.63-.32c.74.24,2.17-.86,3.8-2.59a49.91,49.91,0,0,1,2.43-7.13c.92-2.17,2.3-4.79,4.77-5.9a1.26,1.26,0,0,1,1.59.2,1.36,1.36,0,0,1,.06,1.28c-1,2.81-4.61,8.52-7.95,12.08-.22.89-.42,1.79-.6,2.69-.11.6-.17,1.36.24,1.6.24.15.64.11,1.19-.13a9.74,9.74,0,0,0,3.91-3.11c1-1.12,4.41-4.54,6.06-3.59,1,.6,1,2.41-.06,5.88a.5.5,0,0,1-.63.34.51.51,0,0,1-.33-.63c1.28-4.14.6-4.67.52-4.72-.64-.36-3,1.47-4.79,3.36a10.64,10.64,0,0,1-4.28,3.38A3.12,3.12,0,0,1,215.7,123.8Zm7.1-18.14a2.82,2.82,0,0,0-.37.11c-2.16,1-3.41,3.38-4.26,5.38a46.81,46.81,0,0,0-1.82,5A41.33,41.33,0,0,0,222.73,106C222.82,105.75,222.81,105.67,222.8,105.66Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.19,132a10.08,10.08,0,0,1-3.43-.5,4.93,4.93,0,0,1-3.44-4.08c-.08-1.62.84-3,1.74-4.37s1.82-2.76,1.34-4.11c-.41-1.16-1.71-1.92-4-2.33-8.42-1.53-17.14-.47-25.58.56-7,.85-14.26,1.74-21.38,1.16-3-.23-6.17-1.47-6.39-4.24a.5.5,0,0,1,.46-.54.5.5,0,0,1,.54.46c.17,2.14,2.93,3.12,5.47,3.33,7,.57,14.22-.31,21.18-1.16,8.51-1,17.31-2.12,25.88-.56,2.65.48,4.19,1.46,4.73,3,.65,1.83-.42,3.44-1.45,5-.8,1.22-1.64,2.48-1.57,3.77a3.92,3.92,0,0,0,2.78,3.19,12.68,12.68,0,0,0,4.82.39l50.72-2.45c8.36-.4,17-1.29,22-7.23a.5.5,0,1,1,.76.65c-5.27,6.24-14.09,7.17-22.67,7.58L153,132C152.4,132,151.8,132,151.19,132Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379,199.46a.47.47,0,0,1-.28-.09.49.49,0,0,1-.21-.32l-3-16.49a.5.5,0,0,1,.4-.58l14.94-2.7a.56.56,0,0,1,.38.08.5.5,0,0,1,.2.33l3,16.48a.5.5,0,0,1-.4.58l-14.94,2.7Zm-2.4-16.58,2.8,15.5,14-2.52-2.8-15.5Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.09,198.36a.47.47,0,0,1-.28-.09.49.49,0,0,1-.21-.32l-3-16.49a.5.5,0,0,1,.41-.58l2.77-.5a.54.54,0,0,1,.37.08.49.49,0,0,1,.21.32l3,16.49a.5.5,0,0,1-.41.58l-2.77.5Zm-2.39-16.58,2.8,15.5,1.78-.32-2.79-15.51Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383.58,
    y: 180.99,
    width: 2.82,
    height: 16.75,
    transform: "translate(-27.52 71.42) rotate(-10.23)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.09,198.36a.47.47,0,0,1-.28-.09.49.49,0,0,1-.21-.32l-3-16.49a.5.5,0,0,1,.41-.58l2.77-.5a.54.54,0,0,1,.37.08.49.49,0,0,1,.21.32l3,16.49a.5.5,0,0,1-.41.58l-2.77.5Zm-2.39-16.58,2.8,15.5,1.78-.32-2.79-15.51Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394,196.76a.52.52,0,0,1-.29-.09.46.46,0,0,1-.2-.32l-3-16.49a.5.5,0,0,1,.4-.58l8.26-1.49a.5.5,0,0,1,.58.41l3,16.48a.51.51,0,0,1-.41.58L394,196.75Zm-2.4-16.58,2.8,15.5,7.27-1.31-2.8-15.5Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394,196.76a.52.52,0,0,1-.29-.09.46.46,0,0,1-.2-.32l-3-16.49a.5.5,0,0,1,.4-.58l8.26-1.49a.5.5,0,0,1,.58.41l3,16.48a.51.51,0,0,1-.41.58L394,196.75Zm-2.4-16.58,2.8,15.5,7.27-1.31-2.8-15.5Z",
    style: {
      fill: "#407BFF",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.31,196.15a.52.52,0,0,1-.29-.09.49.49,0,0,1-.2-.32l-3-16.48a.49.49,0,0,1,.4-.58l1.54-.28a.49.49,0,0,1,.37.08.54.54,0,0,1,.21.32l3,16.49a.5.5,0,0,1-.4.58l-1.53.28Zm-2.4-16.58,2.8,15.5.55-.1-2.8-15.5Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.81,
    y: 178.9,
    width: 1.56,
    height: 16.75,
    transform: "translate(-26.97 73.45) rotate(-10.24)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.31,196.15a.52.52,0,0,1-.29-.09.49.49,0,0,1-.2-.32l-3-16.48a.49.49,0,0,1,.4-.58l1.54-.28a.49.49,0,0,1,.37.08.54.54,0,0,1,.21.32l3,16.49a.5.5,0,0,1-.4.58l-1.53.28Zm-2.4-16.58,2.8,15.5.55-.1-2.8-15.5Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.81,177.92l1.36-1.56-6.67,3a19.78,19.78,0,0,0,3.45-3.67,2.32,2.32,0,0,0-4.25-1.85,19.66,19.66,0,0,0-.34,5,20,20,0,0,0-2.06-4.57,2.32,2.32,0,0,0-3.34,3.22,20.07,20.07,0,0,0,4.52,2.24l-7.32-.52,1.82,1-1.85.91s6.36-.47,8.46-.76h.08c2.07-.47,8.2-2.25,8.2-2.25Zm-5.6-3a1.46,1.46,0,1,1,2.67,1.16A19.1,19.1,0,0,1,388,179,19.27,19.27,0,0,1,388.21,174.87Zm-5.15,2.58a1.46,1.46,0,1,1,2.1-2,19.19,19.19,0,0,1,1.61,3.77A19.17,19.17,0,0,1,383.06,177.45Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.13,181.64a.51.51,0,0,1-.49-.36.5.5,0,0,1,.26-.58l1-.49-1-.51a.5.5,0,0,1-.24-.58.48.48,0,0,1,.51-.36l4.37.31a7.64,7.64,0,0,1-2-1.18,2.82,2.82,0,1,1,4.06-3.91,8.47,8.47,0,0,1,1.23,2.28,8.62,8.62,0,0,1,.35-2.57,2.82,2.82,0,1,1,5.17,2.25,7.93,7.93,0,0,1-1.42,1.79l4-1.82a.48.48,0,0,1,.6.15.5.5,0,0,1,0,.63l-.72.83,1.09.1a.51.51,0,0,1,.44.46.48.48,0,0,1-.35.52c-.26.07-6.17,1.79-8.23,2.26l-.11,0c-2.11.28-8.25.74-8.51.76Zm2.23-1.73a.5.5,0,0,1,.12.33.4.4,0,0,1-.06.22l3.47-.29Zm5.6-.26a.49.49,0,0,1,0,.24s0,.05,0,.07l.57-.07.6-.14,0-.06a.49.49,0,0,1-.08-.23.39.39,0,0,1-.18,0,.52.52,0,0,1-.17-.12.5.5,0,0,1-.2.08.54.54,0,0,1-.22,0,.45.45,0,0,1-.11.17A.54.54,0,0,1,387,179.65Zm6.38-1.9-3.21,1.47,3.35-.93a.41.41,0,0,1-.13-.19A.47.47,0,0,1,393.34,177.75Zm-9.23-2.28a1,1,0,0,0-.66.27,1,1,0,0,0-.3.68,1,1,0,0,0,.27.68h0a11.88,11.88,0,0,0,2.53,1.23,11.68,11.68,0,0,0-1.15-2.56,1,1,0,0,0-.67-.3Zm5.44-1a1,1,0,0,0-.88.58,11.72,11.72,0,0,0-.18,2.81,12.32,12.32,0,0,0,1.94-2,1,1,0,0,0-.5-1.27A1,1,0,0,0,389.55,174.49Zm-5.92-.38a1.79,1.79,0,0,0-1.26.51,1.82,1.82,0,0,0-.08,2.55,2.19,2.19,0,0,1-.14-.77,2,2,0,0,1,.6-1.38,2,2,0,0,1,2.16-.37,1.77,1.77,0,0,0-1.25-.54Zm5.92-.62a2,2,0,0,1,2,2,1.83,1.83,0,0,0-1-2.36,1.77,1.77,0,0,0-1.39,0,1.84,1.84,0,0,0-1,.93,2.06,2.06,0,0,1,.66-.42A2,2,0,0,1,389.55,173.49Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M393.81,177.92l1.36-1.56-6.67,3a19.78,19.78,0,0,0,3.45-3.67,2.32,2.32,0,0,0-4.25-1.85,19.66,19.66,0,0,0-.34,5,20,20,0,0,0-2.06-4.57,2.32,2.32,0,0,0-3.34,3.22,20.07,20.07,0,0,0,4.52,2.24l-7.32-.52,1.82,1-1.85.91s6.36-.47,8.46-.76h.08c2.07-.47,8.2-2.25,8.2-2.25Zm-5.6-3a1.46,1.46,0,1,1,2.67,1.16A19.1,19.1,0,0,1,388,179,19.27,19.27,0,0,1,388.21,174.87Zm-5.15,2.58a1.46,1.46,0,1,1,2.1-2,19.19,19.19,0,0,1,1.61,3.77A19.17,19.17,0,0,1,383.06,177.45Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.13,181.64a.51.51,0,0,1-.49-.36.5.5,0,0,1,.26-.58l1-.49-1-.51a.5.5,0,0,1-.24-.58.48.48,0,0,1,.51-.36l4.37.31a7.64,7.64,0,0,1-2-1.18,2.82,2.82,0,1,1,4.06-3.91,8.47,8.47,0,0,1,1.23,2.28,8.62,8.62,0,0,1,.35-2.57,2.82,2.82,0,1,1,5.17,2.25,7.93,7.93,0,0,1-1.42,1.79l4-1.82a.48.48,0,0,1,.6.15.5.5,0,0,1,0,.63l-.72.83,1.09.1a.51.51,0,0,1,.44.46.48.48,0,0,1-.35.52c-.26.07-6.17,1.79-8.23,2.26l-.11,0c-2.11.28-8.25.74-8.51.76Zm2.23-1.73a.5.5,0,0,1,.12.33.4.4,0,0,1-.06.22l3.47-.29Zm5.6-.26a.49.49,0,0,1,0,.24s0,.05,0,.07l.57-.07.6-.14,0-.06a.49.49,0,0,1-.08-.23.39.39,0,0,1-.18,0,.52.52,0,0,1-.17-.12.5.5,0,0,1-.2.08.54.54,0,0,1-.22,0,.45.45,0,0,1-.11.17A.54.54,0,0,1,387,179.65Zm6.38-1.9-3.21,1.47,3.35-.93a.41.41,0,0,1-.13-.19A.47.47,0,0,1,393.34,177.75Zm-9.23-2.28a1,1,0,0,0-.66.27,1,1,0,0,0-.3.68,1,1,0,0,0,.27.68h0a11.88,11.88,0,0,0,2.53,1.23,11.68,11.68,0,0,0-1.15-2.56,1,1,0,0,0-.67-.3Zm5.44-1a1,1,0,0,0-.88.58,11.72,11.72,0,0,0-.18,2.81,12.32,12.32,0,0,0,1.94-2,1,1,0,0,0-.5-1.27A1,1,0,0,0,389.55,174.49Zm-5.92-.38a1.79,1.79,0,0,0-1.26.51,1.82,1.82,0,0,0-.08,2.55,2.19,2.19,0,0,1-.14-.77,2,2,0,0,1,.6-1.38,2,2,0,0,1,2.16-.37,1.77,1.77,0,0,0-1.25-.54Zm5.92-.62a2,2,0,0,1,2,2,1.83,1.83,0,0,0-1-2.36,1.77,1.77,0,0,0-1.39,0,1.84,1.84,0,0,0-1,.93,2.06,2.06,0,0,1,.66-.42A2,2,0,0,1,389.55,173.49Z",
    style: {
      fill: "#407BFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282.38,147.82l-.44-.9a10.13,10.13,0,0,0,5-5.33.88.88,0,0,0,.09-.46l.67-.74c.27.25.51.71.17,1.57A11.15,11.15,0,0,1,282.38,147.82Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.24,148.11l-.48-.88a11.41,11.41,0,0,0,4.84-5.44,1.78,1.78,0,0,0,.21-.68l.85-.51a1.75,1.75,0,0,1-.14,1.59A12.44,12.44,0,0,1,285.24,148.11Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.11,148.4l-.53-.86a12.71,12.71,0,0,0,4.71-5.55,4.15,4.15,0,0,0,.36-.93l1-.17a2.77,2.77,0,0,1-.43,1.52A13.91,13.91,0,0,1,288.11,148.4Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291,148.68l-.58-.82A14.83,14.83,0,0,0,295,142.2l.22-.43c.14-.28.33-.67.37-.79l1,.24a6.67,6.67,0,0,1-.45,1l-.21.42A16,16,0,0,1,291,148.68Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.85,149l-.63-.78a17.92,17.92,0,0,0,4.44-5.77,15.48,15.48,0,0,1,.87-1.48l.82.57a13.37,13.37,0,0,0-.8,1.36A18.92,18.92,0,0,1,293.85,149Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.72,149.24l-.68-.74a21.52,21.52,0,0,0,4.3-5.88,6.54,6.54,0,0,1,1.17-1.67l.66.75a6,6,0,0,0-.95,1.38A22.68,22.68,0,0,1,296.72,149.24Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.58,149.52l-.72-.69a27.92,27.92,0,0,0,4.16-6,5.5,5.5,0,0,1,1.45-1.82l.53.85a4.68,4.68,0,0,0-1.1,1.44A28.86,28.86,0,0,1,299.58,149.52Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.45,149.79l-.76-.64a39.79,39.79,0,0,0,4-6.11,5.13,5.13,0,0,1,1.7-1.94l.45.9a4,4,0,0,0-1.28,1.52A40.63,40.63,0,0,1,302.45,149.79Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.32,150.07l-.81-.59c1.27-1.75,2.56-3.95,3.88-6.23a5,5,0,0,1,1.95-2.05l.38.92a4.08,4.08,0,0,0-1.47,1.62A72.72,72.72,0,0,1,305.32,150.07Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.18,150.34l-.85-.53c.76-1.21,1.54-2.56,2.37-4,.45-.79.91-1.58,1.37-2.36a4.94,4.94,0,0,1,2.2-2.16l.32.95a3.93,3.93,0,0,0-1.66,1.71c-.46.78-.92,1.57-1.37,2.36C309.73,147.76,309,149.12,308.18,150.34Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311,150.61l-.88-.47.38-.71c1-1.8,2-3.84,3.21-5.76a5,5,0,0,1,2.44-2.26l.28,1a4.06,4.06,0,0,0-1.86,1.82c-1.15,1.9-2.23,3.93-3.19,5.72Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.9,150.88l-.91-.41a56.23,56.23,0,0,1,3.44-6.59,5.29,5.29,0,0,1,2.67-2.37l.26,1a4.12,4.12,0,0,0-2.07,1.92A56.67,56.67,0,0,0,313.9,150.88Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.76,151.15l-.94-.35a36.5,36.5,0,0,1,3.3-6.71,5.25,5.25,0,0,1,2.89-2.47l.23,1a4.25,4.25,0,0,0-2.28,2A36,36,0,0,0,316.76,151.15Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.61,151.42l-1-.29a27,27,0,0,1,3.15-6.83,5.55,5.55,0,0,1,3.12-2.57l.21,1a4.58,4.58,0,0,0-2.49,2.13A26.05,26.05,0,0,0,319.61,151.42Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.46,151.69l-1-.23a21.76,21.76,0,0,1,3-7,5.55,5.55,0,0,1,3.35-2.67l.19,1a4.84,4.84,0,0,0-2.7,2.24A20.77,20.77,0,0,0,322.46,151.69Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.31,152l-1-.17a18.49,18.49,0,0,1,2.83-7.07,5.82,5.82,0,0,1,3.57-2.77l.18,1a4.82,4.82,0,0,0-2.92,2.34A17.41,17.41,0,0,0,325.31,152Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.16,152.24l-1-.12a15.86,15.86,0,0,1,2.68-7.19,6.07,6.07,0,0,1,3.79-2.87l.16,1a5.15,5.15,0,0,0-3.13,2.45A14.91,14.91,0,0,0,328.16,152.24Z",
    style: {
      fill: "#407BFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M376.21,149.07H284v-6.21h92.25Zm-91.25-1h90.25v-4.21H285Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-2--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282.58,209.19l-.44-.9a10.06,10.06,0,0,0,5-5.33.88.88,0,0,0,.09-.46l.67-.73c.27.24.51.71.17,1.56A11.11,11.11,0,0,1,282.58,209.19Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.44,209.48l-.48-.87a11.41,11.41,0,0,0,4.84-5.44c.22-.51.21-.66.2-.69l.86-.5a1.73,1.73,0,0,1-.14,1.58A12.44,12.44,0,0,1,285.44,209.48Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.31,209.77l-.53-.85a12.83,12.83,0,0,0,4.71-5.55,4.76,4.76,0,0,0,.36-.94l1-.16a2.81,2.81,0,0,1-.43,1.52A13.88,13.88,0,0,1,288.31,209.77Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.18,210.05l-.58-.81a14.92,14.92,0,0,0,4.57-5.66l.22-.44a6.88,6.88,0,0,0,.37-.79l1,.25a6.69,6.69,0,0,1-.45,1l-.21.42A15.9,15.9,0,0,1,291.18,210.05Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.05,210.34l-.63-.78a17.84,17.84,0,0,0,4.44-5.78,13,13,0,0,1,.87-1.48l.82.57a15,15,0,0,0-.8,1.37A18.92,18.92,0,0,1,294.05,210.34Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.92,210.62l-.68-.74a21.58,21.58,0,0,0,4.3-5.89,6.72,6.72,0,0,1,1.17-1.67l.66.76a5.73,5.73,0,0,0-.95,1.38A23,23,0,0,1,296.92,210.62Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.78,210.89l-.72-.69a27.42,27.42,0,0,0,4.16-6,5.46,5.46,0,0,1,1.45-1.81l.53.84a4.76,4.76,0,0,0-1.1,1.45A29,29,0,0,1,299.78,210.89Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.65,211.17l-.76-.64a39.79,39.79,0,0,0,4-6.12,5.25,5.25,0,0,1,1.71-1.93l.45.89a4.16,4.16,0,0,0-1.28,1.53A40.39,40.39,0,0,1,302.65,211.17Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.52,211.44l-.81-.59a72.17,72.17,0,0,0,3.88-6.23,5,5,0,0,1,2-2.05l.38.93a4,4,0,0,0-1.47,1.62A72.46,72.46,0,0,1,305.52,211.44Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.38,211.72l-.85-.54c.76-1.21,1.54-2.56,2.37-4l1.37-2.35a4.92,4.92,0,0,1,2.2-2.15l.32.94a3.91,3.91,0,0,0-1.66,1.72c-.46.77-.91,1.56-1.36,2.34C309.94,209.13,309.15,210.49,308.38,211.72Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.24,212l-.88-.48.39-.73c1-1.79,2.05-3.83,3.2-5.74a5,5,0,0,1,2.44-2.26l.28,1a4,4,0,0,0-1.86,1.82c-1.14,1.89-2.22,3.91-3.18,5.69Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.1,212.26l-.91-.41a57.23,57.23,0,0,1,3.44-6.6,5.23,5.23,0,0,1,2.67-2.36l.26,1a4.08,4.08,0,0,0-2.08,1.92A58.36,58.36,0,0,0,314.1,212.26Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317,212.53l-.94-.35a36.53,36.53,0,0,1,3.3-6.72,5.28,5.28,0,0,1,2.89-2.46l.23,1a4.24,4.24,0,0,0-2.28,2A36,36,0,0,0,317,212.53Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.81,212.8l-1-.29a27.25,27.25,0,0,1,3.15-6.84,5.49,5.49,0,0,1,3.12-2.56l.21,1a4.54,4.54,0,0,0-2.49,2.13A25.89,25.89,0,0,0,319.81,212.8Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.66,213.07l-1-.23a21.66,21.66,0,0,1,3-7,5.49,5.49,0,0,1,3.34-2.67l.2,1a4.76,4.76,0,0,0-2.7,2.24A20.68,20.68,0,0,0,322.66,213.07Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.51,213.34l-1-.17a18.43,18.43,0,0,1,2.83-7.07,5.78,5.78,0,0,1,3.57-2.77l.18,1a4.89,4.89,0,0,0-2.92,2.34A17.39,17.39,0,0,0,325.51,213.34Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.36,213.61l-1-.11a15.82,15.82,0,0,1,2.68-7.19,6,6,0,0,1,3.79-2.87l.16,1a5.09,5.09,0,0,0-3.13,2.44A14.91,14.91,0,0,0,328.36,213.61Z",
    style: {
      fill: "#407BFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-3--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.88,209.19l-.44-.9a10.06,10.06,0,0,0,5-5.33.88.88,0,0,0,.09-.46l.67-.73c.27.24.51.71.17,1.56A11.11,11.11,0,0,1,327.88,209.19Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.74,209.48l-.48-.87a11.41,11.41,0,0,0,4.84-5.44,1.75,1.75,0,0,0,.21-.69l.85-.5a1.73,1.73,0,0,1-.14,1.58A12.39,12.39,0,0,1,330.74,209.48Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.61,209.77l-.53-.85a12.83,12.83,0,0,0,4.71-5.55,4.21,4.21,0,0,0,.36-.94l1-.16a2.81,2.81,0,0,1-.43,1.52A13.88,13.88,0,0,1,333.61,209.77Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.48,210.05l-.58-.81a14.83,14.83,0,0,0,4.57-5.66l.22-.44c.14-.28.33-.66.37-.79l1,.25a6.25,6.25,0,0,1-.45,1l-.21.42A15.9,15.9,0,0,1,336.48,210.05Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.35,210.34l-.63-.78a17.84,17.84,0,0,0,4.44-5.78,15.48,15.48,0,0,1,.87-1.48l.82.57a13.74,13.74,0,0,0-.8,1.37A18.92,18.92,0,0,1,339.35,210.34Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.22,210.62l-.68-.74a21.58,21.58,0,0,0,4.3-5.89,6.72,6.72,0,0,1,1.17-1.67l.66.76a5.73,5.73,0,0,0-.95,1.38A23,23,0,0,1,342.22,210.62Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.08,210.89l-.72-.69a27.42,27.42,0,0,0,4.16-6,5.46,5.46,0,0,1,1.45-1.81l.53.84a4.76,4.76,0,0,0-1.1,1.45A29,29,0,0,1,345.08,210.89Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348,211.17l-.76-.64a40.47,40.47,0,0,0,4-6.12,5.11,5.11,0,0,1,1.7-1.93l.45.89a4.08,4.08,0,0,0-1.28,1.53A40.63,40.63,0,0,1,348,211.17Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.82,211.44l-.81-.59c1.27-1.75,2.56-3.94,3.88-6.23a5.07,5.07,0,0,1,1.95-2.05l.38.93a4,4,0,0,0-1.47,1.62A74,74,0,0,1,350.82,211.44Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.68,211.72l-.85-.54c.76-1.2,1.54-2.56,2.37-4,.45-.78.91-1.58,1.37-2.36a4.92,4.92,0,0,1,2.2-2.15l.32.94a4,4,0,0,0-1.66,1.72l-1.37,2.35C355.23,209.13,354.45,210.49,353.68,211.72Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.54,212l-.88-.48.38-.7c1-1.81,2-3.85,3.21-5.77a5,5,0,0,1,2.44-2.26l.28,1a4,4,0,0,0-1.86,1.82c-1.15,1.9-2.23,3.93-3.19,5.72Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.4,212.26l-.91-.41a59.65,59.65,0,0,1,3.44-6.6,5.23,5.23,0,0,1,2.67-2.36l.26,1a4,4,0,0,0-2.07,1.92A55,55,0,0,0,359.4,212.26Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.26,212.53l-.94-.35a37.19,37.19,0,0,1,3.3-6.72,5.28,5.28,0,0,1,2.89-2.46l.23,1a4.24,4.24,0,0,0-2.28,2A36,36,0,0,0,362.26,212.53Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.11,212.8l-1-.29a27.25,27.25,0,0,1,3.15-6.84,5.49,5.49,0,0,1,3.12-2.56l.21,1a4.54,4.54,0,0,0-2.49,2.13A25.89,25.89,0,0,0,365.11,212.8Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368,213.07l-1-.23a21.66,21.66,0,0,1,3-7,5.51,5.51,0,0,1,3.35-2.67l.19,1a4.76,4.76,0,0,0-2.7,2.24A20.68,20.68,0,0,0,368,213.07Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.81,213.34l-1-.17a18.43,18.43,0,0,1,2.83-7.07,5.78,5.78,0,0,1,3.57-2.77l.18,1a4.92,4.92,0,0,0-2.92,2.34A17.39,17.39,0,0,0,370.81,213.34Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.66,213.61l-1-.11a15.82,15.82,0,0,1,2.68-7.19,6,6,0,0,1,3.79-2.87l.16,1a5.09,5.09,0,0,0-3.13,2.44A14.91,14.91,0,0,0,373.66,213.61Z",
    style: {
      fill: "#407BFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M376.41,210.44H284.16v-6.21h92.25Zm-91.25-1h90.25v-4.21H285.16Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-4--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.62,300.64l-.43-.9a10.15,10.15,0,0,0,5-5.33.78.78,0,0,0,.09-.46l.68-.74c.26.25.5.71.16,1.57A11.11,11.11,0,0,1,123.62,300.64Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.49,300.93l-.48-.88a11.46,11.46,0,0,0,4.84-5.44,1.6,1.6,0,0,0,.2-.68l.86-.5a1.77,1.77,0,0,1-.14,1.58A12.49,12.49,0,0,1,126.49,300.93Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.35,301.21l-.52-.84a12.87,12.87,0,0,0,4.7-5.55,4.4,4.4,0,0,0,.36-.94l1-.17a2.89,2.89,0,0,1-.44,1.52A13.76,13.76,0,0,1,129.35,301.21Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.22,301.5l-.57-.82a14.92,14.92,0,0,0,4.57-5.66l.21-.44a7.85,7.85,0,0,0,.37-.78l1,.24a7.48,7.48,0,0,1-.44,1l-.21.42A15.91,15.91,0,0,1,132.22,301.5Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.09,301.78l-.62-.78a17.87,17.87,0,0,0,4.43-5.77,16.89,16.89,0,0,1,.87-1.48l.82.57a13.37,13.37,0,0,0-.8,1.36A18.78,18.78,0,0,1,135.09,301.78Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138,302.06l-.67-.74a21.71,21.71,0,0,0,4.29-5.88,6.8,6.8,0,0,1,1.17-1.67l.66.75a6,6,0,0,0-.94,1.38A22.49,22.49,0,0,1,138,302.06Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.83,302.34l-.72-.69a28.65,28.65,0,0,0,4.16-6,5.36,5.36,0,0,1,1.44-1.82l.54.85a4.66,4.66,0,0,0-1.11,1.44A28.86,28.86,0,0,1,140.83,302.34Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.69,302.62l-.76-.65a39.79,39.79,0,0,0,4-6.11,5.26,5.26,0,0,1,1.71-1.94l.44.9a4.12,4.12,0,0,0-1.28,1.52A40.56,40.56,0,0,1,143.69,302.62Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.56,302.89l-.81-.59a72.8,72.8,0,0,0,3.88-6.23,4.92,4.92,0,0,1,2-2.05l.37.92a4,4,0,0,0-1.46,1.62A70.33,70.33,0,0,1,146.56,302.89Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.42,303.16l-.84-.53c.76-1.21,1.54-2.57,2.37-4,.45-.78.9-1.58,1.36-2.35a4.94,4.94,0,0,1,2.2-2.16l.33.95a3.94,3.94,0,0,0-1.67,1.71l-1.36,2.35C151,300.57,150.19,301.93,149.42,303.16Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.28,303.43l-.88-.47.38-.71c1-1.8,2.05-3.84,3.22-5.76a5,5,0,0,1,2.43-2.26l.29.95a4,4,0,0,0-1.87,1.82c-1.15,1.9-2.23,3.93-3.18,5.72Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.14,303.7l-.91-.41a57.74,57.74,0,0,1,3.45-6.59,5.27,5.27,0,0,1,2.66-2.37l.26,1a4.12,4.12,0,0,0-2.07,1.92A56.67,56.67,0,0,0,155.14,303.7Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158,304l-.94-.35a37.16,37.16,0,0,1,3.3-6.71,5.29,5.29,0,0,1,2.89-2.47l.23,1a4.27,4.27,0,0,0-2.27,2A35.51,35.51,0,0,0,158,304Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.85,304.24l-.95-.29a27.16,27.16,0,0,1,3.14-6.83,5.58,5.58,0,0,1,3.12-2.57l.21,1a4.62,4.62,0,0,0-2.49,2.13A26.41,26.41,0,0,0,160.85,304.24Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.71,304.51l-1-.22a21.94,21.94,0,0,1,3-7,5.55,5.55,0,0,1,3.35-2.67l.19,1a4.88,4.88,0,0,0-2.7,2.24A20.75,20.75,0,0,0,163.71,304.51Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.56,304.78l-1-.16a18.34,18.34,0,0,1,2.84-7.08,5.78,5.78,0,0,1,3.56-2.77l.18,1a4.83,4.83,0,0,0-2.91,2.34A17.25,17.25,0,0,0,166.56,304.78Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.4,305.06l-1-.12a16,16,0,0,1,2.68-7.19,6.07,6.07,0,0,1,3.79-2.87l.17,1a5.14,5.14,0,0,0-3.14,2.45A15,15,0,0,0,169.4,305.06Z",
    style: {
      fill: "#407BFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M217.45,301.89H125.2v-6.21h92.25Zm-91.25-1h90.25v-4.21H126.2Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.34,110.75c2.76.74,7.41,1,8-2.74,1-6.06-9-3.13-12-3.36a.57.57,0,0,0-.1,1.13c2.5.19,11-2.12,11,1.65,0,3.22-4.46,2.82-6.55,2.26-.7-.19-1.1.87-.39,1.06Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.53,111.68a12.93,12.93,0,0,1-3.32-.45h0a1,1,0,0,1-.7-1.22,1.11,1.11,0,0,1,1.35-.81c1.76.48,4.15.6,5.26-.26a1.74,1.74,0,0,0,.66-1.5,1.25,1.25,0,0,0-.41-1c-1.19-1-4.59-.66-7.08-.38a19,19,0,0,1-3,.22,1,1,0,0,1-.85-.58,1.13,1.13,0,0,1,.09-1.11,1,1,0,0,1,.94-.44,18.86,18.86,0,0,0,2.94-.2c3.13-.35,7-.78,8.74,1a3.48,3.48,0,0,1,.74,3.12,3.79,3.79,0,0,1-1.74,2.72A6.68,6.68,0,0,1,392.53,111.68Zm-3.06-1.41c1.93.51,4.54.71,6.1-.3a2.83,2.83,0,0,0,1.3-2,2.55,2.55,0,0,0-.48-2.27c-1.37-1.44-5.15-1-7.91-.72a19.69,19.69,0,0,1-3.13.21.1.1,0,0,0-.05.13,19.18,19.18,0,0,0,2.88-.21c2.82-.32,6.33-.72,7.85.62a2.22,2.22,0,0,1,.75,1.74,2.71,2.71,0,0,1-1,2.3c-2,1.51-5.71.55-6.13.44A.24.24,0,0,0,389.47,110.27Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.61,139.3h-.19l-10.9-.95a2.17,2.17,0,0,1-2-2.34l2.18-24.92a2.15,2.15,0,0,1,1.14-1.72l.15-1.75,13.24,1.16-.16,1.75a2.14,2.14,0,0,1,.83,1.89l-2.18,24.92a2.14,2.14,0,0,1-.76,1.46A2.17,2.17,0,0,1,387.61,139.3Zm-8.67-30.6-.12,1.37-.3.1a1.16,1.16,0,0,0-.79,1l-2.18,24.91a1.17,1.17,0,0,0,1.06,1.26l10.9.95a1.1,1.1,0,0,0,.84-.26,1.12,1.12,0,0,0,.41-.79l2.18-24.92a1.15,1.15,0,0,0-.59-1.11l-.29-.16.12-1.37Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.61,139.3h-.19l-10.9-.95a2.17,2.17,0,0,1-2-2.34l2.18-24.92a2.15,2.15,0,0,1,1.14-1.72l.15-1.75,13.24,1.16-.16,1.75a2.14,2.14,0,0,1,.83,1.89l-2.18,24.92a2.14,2.14,0,0,1-.76,1.46A2.17,2.17,0,0,1,387.61,139.3Zm-8.67-30.6-.12,1.37-.3.1a1.16,1.16,0,0,0-.79,1l-2.18,24.91a1.17,1.17,0,0,0,1.06,1.26l10.9.95a1.1,1.1,0,0,0,.84-.26,1.12,1.12,0,0,0,.41-.79l2.18-24.92a1.15,1.15,0,0,0-.59-1.11l-.29-.16.12-1.37Z",
    style: {
      fill: "#407BFF",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.14,110.15h-.2l-10.84-1a2.18,2.18,0,0,1-1.49-.77,2.21,2.21,0,0,1-.5-1.6v-.16a2.2,2.2,0,0,1,2.37-2l10.85,1a2.2,2.2,0,0,1,2,2.37l0,.16a2.18,2.18,0,0,1-2.17,2Zm-10.84-4.48a1.18,1.18,0,0,0-.76.27,1.22,1.22,0,0,0-.42.81v.16a1.17,1.17,0,0,0,.27.86,1.12,1.12,0,0,0,.81.42l10.84,1a1.21,1.21,0,0,0,.87-.27,1.19,1.19,0,0,0,.42-.81v-.15a1.18,1.18,0,0,0-.27-.87,1.22,1.22,0,0,0-.81-.42l-10.84-1Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.59,
    y: 105.64,
    width: 14.26,
    height: 3.53,
    rx: 1.69,
    transform: "translate(10.83 -33.12) rotate(5)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.14,110.15h-.2l-10.84-1a2.18,2.18,0,0,1-1.49-.77,2.21,2.21,0,0,1-.5-1.6v-.16a2.2,2.2,0,0,1,2.37-2l10.85,1a2.2,2.2,0,0,1,2,2.37l0,.16a2.18,2.18,0,0,1-2.17,2Zm-10.84-4.48a1.18,1.18,0,0,0-.76.27,1.22,1.22,0,0,0-.42.81v.16a1.17,1.17,0,0,0,.27.86,1.12,1.12,0,0,0,.81.42l10.84,1h0a1.21,1.21,0,0,0,.87-.27,1.19,1.19,0,0,0,.42-.81v-.15a1.18,1.18,0,0,0-.27-.87,1.22,1.22,0,0,0-.81-.42l-10.84-1Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.78,115.64a13.34,13.34,0,0,0-7.43.07l-1.61,18.46a2.15,2.15,0,0,0,2,2.34l6.89.6a2.15,2.15,0,0,0,2.34-2L389.61,116A10,10,0,0,1,385.78,115.64Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.78,115.64a13.34,13.34,0,0,0-7.43.07l-1.61,18.46a2.15,2.15,0,0,0,2,2.34l6.89.6a2.15,2.15,0,0,0,2.34-2L389.61,116A10,10,0,0,1,385.78,115.64Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.69,120.81a3.44,3.44,0,1,1-3.13-3.72A3.46,3.46,0,0,1,385.69,120.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.27,124.45h-.35a3.94,3.94,0,1,1,4.27-3.58h0a4,4,0,0,1-1.4,2.67A3.89,3.89,0,0,1,382.27,124.45Zm0-6.87a2.94,2.94,0,0,0-.25,5.86,2.88,2.88,0,0,0,2.14-.68,2.93,2.93,0,0,0-1.63-5.17Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M385.69,120.81a3.44,3.44,0,1,1-3.13-3.72A3.46,3.46,0,0,1,385.69,120.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.27,124.45h-.35a3.94,3.94,0,1,1,4.27-3.58h0a4,4,0,0,1-1.4,2.67A3.89,3.89,0,0,1,382.27,124.45Zm0-6.87a2.94,2.94,0,0,0-.25,5.86,2.88,2.88,0,0,0,2.14-.68,2.93,2.93,0,0,0-1.63-5.17Z",
    style: {
      fill: "#407BFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M381.9,117.9a2.65,2.65,0,0,0-.84.26.31.31,0,0,0-.09.48L382.1,120l.15-1.74A.31.31,0,0,0,381.9,117.9Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.77,120.26l-1.13-1.35a.31.31,0,0,0-.48,0,2.53,2.53,0,0,0-.41.78.3.3,0,0,0,.27.4Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.73,120.68l-1.75-.15a.31.31,0,0,0-.33.35,2.65,2.65,0,0,0,.26.84.32.32,0,0,0,.48.09Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.67,118.27l-.15,1.75,1.34-1.13a.31.31,0,0,0,0-.48,2.59,2.59,0,0,0-.79-.41A.32.32,0,0,0,382.67,118.27Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.76,120.77l1.12,1.35a.32.32,0,0,0,.49,0,2.74,2.74,0,0,0,.4-.78.31.31,0,0,0-.27-.41Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.79,120.35l1.75.15a.31.31,0,0,0,.34-.35,2.44,2.44,0,0,0-.27-.84.3.3,0,0,0-.47-.09Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382,121l-1.35,1.13a.31.31,0,0,0,0,.48,2.9,2.9,0,0,0,.78.41.31.31,0,0,0,.4-.28Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.43,121l-.15,1.75a.31.31,0,0,0,.35.34,2.51,2.51,0,0,0,.84-.27.31.31,0,0,0,.09-.47Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.35,131.6a3.44,3.44,0,1,1-3.12-3.72A3.43,3.43,0,0,1,387.35,131.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.93,135.24h-.34a3.94,3.94,0,0,1,.68-7.85,3.94,3.94,0,0,1,3.58,4.27h0A3.94,3.94,0,0,1,383.93,135.24Zm0-6.87a2.94,2.94,0,0,0-2.93,2.68,2.88,2.88,0,0,0,.68,2.14,2.94,2.94,0,1,0,2.5-4.81Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M387.35,131.6a3.44,3.44,0,1,1-3.12-3.72A3.43,3.43,0,0,1,387.35,131.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.93,135.24h-.34a3.94,3.94,0,0,1,.68-7.85,3.94,3.94,0,0,1,3.58,4.27h0A3.94,3.94,0,0,1,383.93,135.24Zm0-6.87a2.94,2.94,0,0,0-2.93,2.68,2.88,2.88,0,0,0,.68,2.14,2.94,2.94,0,1,0,2.5-4.81Z",
    style: {
      fill: "#407BFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M383.57,128.69a2.49,2.49,0,0,0-.85.27.31.31,0,0,0-.09.47l1.13,1.35.15-1.75A.31.31,0,0,0,383.57,128.69Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.44,131.05l-1.13-1.35a.32.32,0,0,0-.49,0,2.74,2.74,0,0,0-.4.78.32.32,0,0,0,.27.41Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.4,131.47l-1.75-.15a.31.31,0,0,0-.34.35,2.67,2.67,0,0,0,.27.84.31.31,0,0,0,.47.09Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.34,129.06l-.16,1.75,1.35-1.13a.31.31,0,0,0,0-.48,2.64,2.64,0,0,0-.78-.41A.31.31,0,0,0,384.34,129.06Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.42,131.56l1.13,1.35a.31.31,0,0,0,.48,0,2.53,2.53,0,0,0,.41-.78.32.32,0,0,0-.27-.41Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.46,131.14l1.75.15a.31.31,0,0,0,.33-.35,2.65,2.65,0,0,0-.26-.84.32.32,0,0,0-.48-.09Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.67,131.8l-1.34,1.13a.31.31,0,0,0,0,.48,2.59,2.59,0,0,0,.79.41.32.32,0,0,0,.4-.27Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.1,131.84l-.16,1.74a.32.32,0,0,0,.35.34,2.44,2.44,0,0,0,.84-.27.3.3,0,0,0,.09-.47Z",
    style: {
      fill: "#407BFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M450.47,387.34c-1.18,8.83-5.91,18.07-14,21.73-44.06,19.86-88.68,19.48-128.47-.86C301.72,405,295,396,294.61,389,316.43,382.54,406,374,450.47,387.34Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.47,387.34c-1.18,8.83-5.91,18.07-14,21.73-44.06,19.86-88.68,19.48-128.47-.86C301.72,405,295,396,294.61,389,316.43,382.54,406,374,450.47,387.34Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--group--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M393.66,291.64a6.4,6.4,0,0,1,0,.77c0,.91,0,1.82-.06,2.75-.07,3.13-.25,6.21-.51,9.32a107.39,107.39,0,0,1-3.07,18.85l-.74,2.41-.19.59,0,.16-.07.23-.23.64c-2.5,12.06-28.86,2.13-31.24-6.9l-.31-4.45,20.64,6.7c1-5.62,2.59-13.27,2.82-19,.17-2.91.26-5.84.34-8.77,0-.9,0-1.81,0-2.7a6.3,6.3,0,0,1,12.57-.62Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.82,295.82l9.27,25a1,1,0,0,1,.06.4l-.08,2.35L368.51,322a1,1,0,0,1-.24-.36l-10-24.8a1.07,1.07,0,0,1,.54-1.36l.57-.26A1.05,1.05,0,0,1,360.82,295.82Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.82,295.82l9.27,25a1,1,0,0,1,.06.4l-.08,2.35L368.51,322a1,1,0,0,1-.24-.36l-10-24.8a1.07,1.07,0,0,1,.54-1.36l.57-.26A1.05,1.05,0,0,1,360.82,295.82Z",
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361,305.26c0,.12.11.24.16.37s.18-.07.29-.09.05-.42-.07-.61c-.92-1.33-2.26-2.66-2.83-4.18a2.83,2.83,0,0,1-.25-1.27.68.68,0,0,1,.71-.69,1,1,0,0,0-.35-1.08c-.3-.14-.64.06-.91.27a1.74,1.74,0,0,0-.42,2.16C358.22,302,360.24,303.37,361,305.26Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.44,319.14a18.85,18.85,0,0,1-1.79,1.33,9.75,9.75,0,0,1-3.67,1.6,2.31,2.31,0,0,1-2.43-1.61,0,0,0,0,1,0,0,2.12,2.12,0,0,1-.11-.61l-.19-3.81,6.09-7.21Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.86,313.06l.34,2.19a2.62,2.62,0,0,1-1.95,2.94l-3.81.95-2.11-10.34L369.2,311A2.61,2.61,0,0,1,370.86,313.06Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.05,286.63c2.29,7.56-1.8,26.39-1.8,26.39l-19.86-.4c2.28-7.21,2.31-17.26,5.41-24.16C382.71,282.26,393.54,278.4,396.05,286.63Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.05,286.63c2.29,7.56-1.8,26.39-1.8,26.39l-19.86-.4c2.28-7.21,2.31-17.26,5.41-24.16C382.71,282.26,393.54,278.4,396.05,286.63Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.42,278.12A4.72,4.72,0,0,1,428,283v.13a193,193,0,0,0,.4,22.94c.47,6.43,1.2,12.52,2,18,1.83,12.87,4,22.53,4.29,25.9l-42.81,8.21c-11.18-33.55-11.4-59.22-10.26-68.71a7.85,7.85,0,0,1,5.28-6.53c1.62-.54,3.56-1.15,5.63-1.69.73-.14,1.47-.36,2.21-.52a162.57,162.57,0,0,1,18.65-2.4c1.18-.09,2.38-.14,3.56-.19C419.3,278.06,421.56,278.08,423.42,278.12Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.42,278.12A4.72,4.72,0,0,1,428,283v.13a193,193,0,0,0,.4,22.94c.47,6.43,1.2,12.52,2,18,1.83,12.87,4,22.53,4.29,25.9l-42.81,8.21c-11.18-33.55-11.4-59.22-10.26-68.71a7.85,7.85,0,0,1,5.28-6.53c1.62-.54,3.56-1.15,5.63-1.69.73-.14,1.47-.36,2.21-.52a162.57,162.57,0,0,1,18.65-2.4c1.18-.09,2.38-.14,3.56-.19C419.3,278.06,421.56,278.08,423.42,278.12Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.93,257.58c-.42,6.14-.22,17.27,4.48,20.75-8.7,8.73-13.23,19.48-15.48,17.78-1.18-.89-4.06-13.34-3.16-15.44,6.49-2.44,5.69-7.37,4-11.89Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.78,262.14l-6,6.63a19.27,19.27,0,0,1,1,3.24c2.51-.69,5.66-3.94,5.59-6.65A8.83,8.83,0,0,0,404.78,262.14Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.83,244.78c-3.92.94-4.76,8.19.36,13S390.11,243.5,384.83,244.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.51,246.93c2.05,7.94,3.65,12.48,1,17.75-4,7.93-14.73,7.5-19.12.33-3.94-6.45-6.65-18.35,0-23.92a11.19,11.19,0,0,1,18.12,5.84Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.87,247.79c.3,1.68,2.24,3.79,2.24,3.79a7.52,7.52,0,0,1,1.18,5.53l3,.07a4.73,4.73,0,0,1,3.83-5.22q-.7,5-1.85,9.89A24.82,24.82,0,0,0,414.43,251a14.22,14.22,0,0,0,.44-6,7.71,7.71,0,0,0-3.07-5.09,8.41,8.41,0,0,0-7.65-.44C399.76,241.12,398.73,241.3,399.87,247.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.69,252.65a7.78,7.78,0,0,1-2.14,5.55c-1.9,2-4.22.61-4.85-1.9-.57-2.26-.26-6,2.2-7S411.6,250.12,411.69,252.65Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.61,253.94c.21.63,0,1.26-.38,1.4s-.91-.28-1.13-.91,0-1.26.38-1.39S394.41,253.31,394.61,253.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.46,256.26c.21.64,0,1.26-.38,1.4s-.91-.27-1.12-.91,0-1.25.38-1.38S387.24,255.63,387.46,256.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.88,249.9a.4.4,0,0,1-.41,0,3.1,3.1,0,0,0-2.78-.46.41.41,0,0,1-.54-.17l0-.08a.38.38,0,0,1,.19-.5h0a3.84,3.84,0,0,1,3.53.55.37.37,0,0,1,.11.53h0A.38.38,0,0,1,395.88,249.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394,264.1h0a6,6,0,0,0,3.52-4.28.21.21,0,0,0-.17-.24.23.23,0,0,0-.25.18,5.66,5.66,0,0,1-3.26,3.95.23.23,0,0,0-.1.28A.22.22,0,0,0,394,264.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.37,253.8a.37.37,0,0,1-.23,0,.39.39,0,0,1-.34-.44,3.88,3.88,0,0,1,2-3,.38.38,0,0,1,.51.18h0a.37.37,0,0,1-.17.5h0a3.12,3.12,0,0,0-1.56,2.33A.37.37,0,0,1,383.37,253.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.73,282.7c-3.68-.15-5,1.31-7,6.53-1.83,4.82-1.72,18.13-1.72,18.13.31,7.26-.69,6.55,6.19,6.35,4.41-.13,10.05.21,10.05.21S432.74,283.16,421.73,282.7Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.25,290.91c.09.91.12,1.83.18,2.75.2,3.12-.19,1.62-.17,4.75a109.52,109.52,0,0,1-1.43,19l-.53,2.45-.13.61,0,.16-.05.24-.18.66c-1.07,3.71-2.07,5.39-3.93,6.38-4.26,2.48-24.7,4.51-30.19,3.43l-.11-6.26s20.11-3.74,22.18-5.26a4.09,4.09,0,0,0,1.33-1.5c0-.15-.19.52,0-.52l.27-2c.51-5.68.59-18.35.41-21.28-.05-.9-.11-1.8-.18-2.69a6.3,6.3,0,0,1,5.5-6.75S434.57,284.44,435.25,290.91Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.26,316.87l8.58,20s6.13-2.67,9.08-1.23a29.16,29.16,0,0,1,5.17,3.28l-6.8-22S366.68,310.56,357.26,316.87Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.29,316.88l6.8,22L392.35,334a3.67,3.67,0,0,0,2.16-4.45L390.18,315a3.69,3.69,0,0,0-3.17-2.61C383.73,312,377.87,312.24,373.29,316.88Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M373.29,316.88l6.8,22L392.35,334a3.67,3.67,0,0,0,2.16-4.45L390.18,315a3.69,3.69,0,0,0-3.17-2.61C383.73,312,377.87,312.24,373.29,316.88Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M357.26,316.87l8.58,20s6.13-2.67,9.08-1.23a29.16,29.16,0,0,1,5.17,3.28l-6.8-22S366.68,310.56,357.26,316.87Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.06,338.66c-4.44-.93-8.8-1.93-12.35-.09a2.73,2.73,0,0,1-3.77-1.33c-2.17-4.94-5.31-11.09-7.43-15.82a2.73,2.73,0,0,1,1.07-3.45l.62-.38c2.08-1.45,12.29-3.66,15.07,1.78C374.29,321.35,379.61,338.22,380.06,338.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.84,327.43a5.83,5.83,0,0,1-4.48,7.18,9.47,9.47,0,0,0-4.89,2.53,9.11,9.11,0,0,1-3.17,2.1v0l-6.78-20.51-.17.15c.6-3.27,5.3-5.32,8.36-5.74a12.49,12.49,0,0,1,4.25.28,5.88,5.88,0,0,1,4.4,4.27C393,320.13,393.94,323.83,394.84,327.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.3,339.24s-1.79.76-2.67-.67L373,318.86s.9,1.24,2.34,0l.17-.15,6.78,20.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.3,339.24s-1.79.76-2.67-.67L373,318.86s.9,1.24,2.34,0l.17-.15,6.78,20.51Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.07,325.12l-8-4.82L389.76,332s7.71,2.59,9.53-1.33Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "383.47 321.18 382.83 330.87 389.77 331.95 391.09 320.3 383.47 321.18",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.12,282.45c5.27,5.87,6,27.46,6,27.46l-21.57.21s-3.49-11.75-1.33-21.73C417.57,277.56,425.72,275.33,432.12,282.45Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.12,282.45c5.27,5.87,6,27.46,6,27.46l-21.57.21s-3.49-11.75-1.33-21.73C417.57,277.56,425.72,275.33,432.12,282.45Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M383.09,247.53a5.26,5.26,0,0,0,4.35,1.35,3.54,3.54,0,0,1-1.83-3.12c1.79,1.16,5.11,2.4,7.2,2-1.7-.35-2.4-1.35-2.5-3.09,5.33-1,8.42,0,7.77,4.26,6.62-4.23.65-8.79,11.64-10-4.37-3.76-7.06-7.62-15.48-6.16-5.68,1-12.62,6.16-12.76,10.33A5.77,5.77,0,0,0,383.09,247.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.33 388.58 403.03 395.13 409.13 398.27 406.54 405.07 400.51 402.91 385.79 397.63 390.33 388.58",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.33 388.58 403.03 395.13 400.51 402.91 385.79 397.63 390.33 388.58",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.58 395.89 361.66 408.9 358.82 415.15 351.91 412.9 353.77 406.77 358.31 391.81 367.58 395.89",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.91 396.3 361.43 409.03 353.63 406.56 358.83 391.81 367.91 396.3",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.4,370.89l-.55.38c-.6.4-1.15.78-1.63,1.09q-.32-.37-.66-.72a11.49,11.49,0,0,1,2.13-.63C400.92,371,401.16,370.92,401.4,370.89Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.54,350.05,392,358.15s-13.83,2.63-29.13,4.79l-1.35.19c-2.6.39-5.17.87-7.65,1.45l-.22,0a84.57,84.57,0,0,0-18,6.16,1.19,1.19,0,0,0-.25.13,18.45,18.45,0,0,0-5.52,3.94,10.57,10.57,0,0,0-.76.92c-2.56,2.91-5.24,7.71-3.16,13.87,0,0,2.46,6.64,23.22,8.54S396.21,402,396.21,402l1.73-8.59-1-.65a15.9,15.9,0,0,0,3.82-2.57c7.72.47,24,1,29.62-2.2,11.62-6.58-14.06-19.35-29-17.13,6.83-4.69,19.86-13.58,38.19-10.6.66.11.89,1,1.23,1.69A34.58,34.58,0,0,0,434.54,350.05Zm-33.69,21.22c-.6.4-1.15.78-1.63,1.09q-.32-.37-.66-.72a11.49,11.49,0,0,1,2.13-.63c.23,0,.47-.09.71-.12Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.54,350.05,392,358.15s-13.83,2.63-29.13,4.79l-1.35.19c-2.6.39-5.17.87-7.65,1.45l-.22,0a84.57,84.57,0,0,0-18,6.16,1.19,1.19,0,0,0-.25.13,18.45,18.45,0,0,0-5.52,3.94,10.57,10.57,0,0,0-.76.92c-2.56,2.91-5.24,7.71-3.16,13.87,0,0,2.46,6.64,23.22,8.54S396.21,402,396.21,402l1.73-8.59-1-.65a15.9,15.9,0,0,0,3.82-2.57c7.72.47,24,1,29.62-2.2,11.62-6.58-14.06-19.35-29-17.13,6.83-4.69,19.86-13.58,38.19-10.6.66.11.89,1,1.23,1.69A34.58,34.58,0,0,0,434.54,350.05Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.55,379.71s11-1.14,18.89.38S397,392.79,397,392.79s-25.69-17.09-38.79-17.61S347,381.53,347,381.53",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "397.64 404.71 391.04 404.62 396.72 388.37 401.95 391.4 397.64 404.71",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "397.64 404.71 391.04 404.62 396.72 388.37 401.95 391.4 397.64 404.71",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M371.38,330.37c16.51-12.09,60.06,20.86,63.75,24.31a31,31,0,0,1,3.42,3.76l0,0,.52.7c.43.61.83,1.22,1.19,1.84a1.25,1.25,0,0,0,.08.12c.17.29.32.57.47.86,4.36,8.46.2,25-10.48,26.15-24.84,2.62-43.15-37.83-43.15-37.83Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.32,349.21s-.26,11.29-10.58,31.94c-3.19,6.38-13.14,25.6-13.14,25.6l-9.66-3.42s.09-.79.27-2.19c.37-3.08,1.15-9.11,2.34-16.47,1.9-11.77,4.84-27,8.76-38.93,2.21-6.76,3.25-14.75,7.59-16Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "352.24 402.64 352.6 396.06 368.61 402.4 365.37 407.5 352.24 402.64",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "352.24 402.64 352.6 396.06 368.61 402.4 365.37 407.5 352.24 402.64",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M343.71,408.78a1.55,1.55,0,0,0,.19,1.25,4.32,4.32,0,0,0,.45.5,3.48,3.48,0,0,0,1.51.9l.5.16a14.17,14.17,0,0,0,2.26.52.17.17,0,0,0,.18-.14.26.26,0,0,0-.09-.26c-.07-.08-.24-.26-.49-.51l-.1-.12,0,0-.73-.71c-1.08-1-2.51-2.21-3.22-2.06A.65.65,0,0,0,343.71,408.78Zm.57,0a.63.63,0,0,1,.38.06,13,13,0,0,1,2.85,2.22,1.21,1.21,0,0,1,.19.2,3.83,3.83,0,0,1,.28.29c-.29-.05-.58-.12-.83-.18a8.69,8.69,0,0,1-1.69-.59,2.76,2.76,0,0,1-1.23-1,1,1,0,0,1-.13-.85A.22.22,0,0,1,344.28,408.78Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.75,405.91c-.5.67,0,3,.62,4.44a6.16,6.16,0,0,0,.34.72s0,0,0,0a.16.16,0,0,0,.07.07.25.25,0,0,0,.12,0,.17.17,0,0,0,.16-.11,0,0,0,0,0,0,0v0a7.09,7.09,0,0,0,.43-4,2.08,2.08,0,0,0-.83-1.13C347.17,405.55,346.9,405.71,346.75,405.91Zm.32.34s.13-.16.48.07l.11.08a1.53,1.53,0,0,1,.49.76,6.24,6.24,0,0,1-.3,3.31C347.23,409.12,346.71,406.75,347.07,406.25Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.07,411l6.95,3.13a1,1,0,0,1,.57.93l-2.23,8.46a1.2,1.2,0,0,1-1.5,1.22l-.15-.05c-14.25-3.85-19.22-6.83-20.77-7.55-4.44-2.07-3-5.71-1.44-5.49,6.92,1,11.6,1,14.23-.24C351.69,410.08,351.55,410.79,352.07,411Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.31,411.71a1.61,1.61,0,0,0,1.27-.08,5.39,5.39,0,0,0,.54-.4,3.63,3.63,0,0,0,1-1.43c.07-.16.14-.31.2-.48a12.85,12.85,0,0,0,.72-2.2.17.17,0,0,0-.12-.2.27.27,0,0,0-.27.07l-.55.44-.13.1h0c-.23.19-.5.41-.78.66-1.11,1-2.43,2.3-2.34,3A.66.66,0,0,0,402.31,411.71Zm.05-.57a.66.66,0,0,1,.1-.38,13,13,0,0,1,2.47-2.63l.21-.18.32-.24c-.08.28-.17.55-.26.81a8.85,8.85,0,0,1-.73,1.62,2.77,2.77,0,0,1-1.07,1.14,1,1,0,0,1-.86.05A.23.23,0,0,1,402.36,411.14Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.73,408.42c.62.56,3,.24,4.48-.22a5.78,5.78,0,0,0,.75-.27l0,0s.06,0,.07-.06a.17.17,0,0,0,.05-.12.17.17,0,0,0-.09-.17h0a7.1,7.1,0,0,0-4-.79,2.09,2.09,0,0,0-1.21.72C399.41,408,399.55,408.25,399.73,408.42Zm.37-.29s-.15-.14.11-.47l.09-.1a1.55,1.55,0,0,1,.8-.42,6.1,6.1,0,0,1,3.27.6C403,408.23,400.56,408.53,400.1,408.13Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405,404.25l3.83-7a1,1,0,0,1,1-.49l8.91,1.21a1.21,1.21,0,0,1,1.08,1.6l-.06.15c-5.13,13.84-8.36,17.07-9.22,18.56-2.46,4.23-6,2.44-5.59.93,1.65-6.8,1.06-8.94.05-11.68A5.79,5.79,0,0,1,405,404.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.15,255.54l-.91-.08c0-.15.16-1.52,1.1-1.91a2,2,0,0,1,2.06.6l-.58.7c-.49-.4-.88-.56-1.12-.46S389.18,255.24,389.15,255.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "397.26 251.67 396.96 250.81 406.54 247.79 408.35 248 408.25 248.9 406.64 248.72 397.26 251.67",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385,260.9a1.85,1.85,0,0,1-1.67-1.06l-1.83-3.92a1.44,1.44,0,0,1,0-1.17,1.41,1.41,0,0,1,.86-.78l4.33-1.42a1.45,1.45,0,0,1,1.08.08,1.37,1.37,0,0,1,.7.83l1.33,4a1.87,1.87,0,0,1-.11,1.41,1.84,1.84,0,0,1-1.07.92l-3,1A1.88,1.88,0,0,1,385,260.9Zm2.11-7.42-.13,0-4.33,1.42a.43.43,0,0,0-.25.23.4.4,0,0,0,0,.34l1.84,3.93a.84.84,0,0,0,1,.44l3-1a.85.85,0,0,0,.49-.42.86.86,0,0,0,0-.65l-1.33-4a.37.37,0,0,0-.2-.24A.45.45,0,0,0,387.06,253.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.42,258.31a1.85,1.85,0,0,1-1.75-1.24l-1.38-4a1.43,1.43,0,0,1,.88-1.8l4.31-1.48a1.43,1.43,0,0,1,1.16.11,1.45,1.45,0,0,1,.69.93l.9,4.24a1.84,1.84,0,0,1-1.2,2.12l-3,1A1.78,1.78,0,0,1,393.42,258.31Zm2.52-7.62-.14,0-4.3,1.48a.39.39,0,0,0-.24.21.4.4,0,0,0,0,.32l1.38,4a.84.84,0,0,0,1.07.52l3-1a.85.85,0,0,0,.55-1l-.9-4.24a.45.45,0,0,0-.2-.27A.42.42,0,0,0,395.94,250.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390,254.85a23.7,23.7,0,0,1-1.28,6.4,3.85,3.85,0,0,0,3.22-.42Z",
    style: {
      fill: "#a02724"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.35,334.49c.78,1.6,1.53,3.46.84,5.11a4,4,0,0,1-5,1.85,5.85,5.85,0,0,1-3.35-4.56c-.19-1.21-.09-2.46-.28-3.68-.55-3.51-3.32-6.18-6-8.58-.91,3.33.31,6.88,2,9.88s3.94,5.71,5.3,8.89,1.68,7.09-.33,9.9a1.52,1.52,0,0,1-.61.57,1.54,1.54,0,0,1-1.15-.08c-3.43-1.24-5.12-5.07-6-8.61s-1.36-7.39-3.76-10.14c.34,4.51,3,8.5,4,12.93a17.12,17.12,0,0,1-5.14,15.84,1.75,1.75,0,0,1-1.27.61c-.71-.08-1.06-.88-1.21-1.58-1.53-6.91,2.43-14.95-1.53-20.82l-3.39,4.54A8.4,8.4,0,0,1,89.1,349a2.77,2.77,0,0,1-3.21-.22c-1.28-1.27-.4-3.43.59-4.93a76,76,0,0,1,8.73-10.93c-1.51-1.15-3.57.2-5.09,1.34s-4.12,1.85-4.94.14a2.74,2.74,0,0,1-.08-1.79c.66-2.92,3.18-5,5.74-6.57s5.37-2.84,7.34-5.09a9.48,9.48,0,0,1-4.93-.93c-1.45-.88-2.32-2.94-1.35-4.33a45.16,45.16,0,0,1,7.49-4.49c2.71-.25,4.68,2.63,6.31,4.45A84.42,84.42,0,0,1,118.35,334.49Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.35,334.49c.78,1.6,1.53,3.46.84,5.11a4,4,0,0,1-5,1.85,5.85,5.85,0,0,1-3.35-4.56c-.19-1.21-.09-2.46-.28-3.68-.55-3.51-3.32-6.18-6-8.58-.91,3.33.31,6.88,2,9.88s3.94,5.71,5.3,8.89,1.68,7.09-.33,9.9a1.52,1.52,0,0,1-.61.57,1.54,1.54,0,0,1-1.15-.08c-3.43-1.24-5.12-5.07-6-8.61s-1.36-7.39-3.76-10.14c.34,4.51,3,8.5,4,12.93a17.12,17.12,0,0,1-5.14,15.84,1.75,1.75,0,0,1-1.27.61c-.71-.08-1.06-.88-1.21-1.58-1.53-6.91,2.43-14.95-1.53-20.82l-3.39,4.54A8.4,8.4,0,0,1,89.1,349a2.77,2.77,0,0,1-3.21-.22c-1.28-1.27-.4-3.43.59-4.93a76,76,0,0,1,8.73-10.93c-1.51-1.15-3.57.2-5.09,1.34s-4.12,1.85-4.94.14a2.74,2.74,0,0,1-.08-1.79c.66-2.92,3.18-5,5.74-6.57s5.37-2.84,7.34-5.09a9.48,9.48,0,0,1-4.93-.93c-1.45-.88-2.32-2.94-1.35-4.33a45.16,45.16,0,0,1,7.49-4.49c2.71-.25,4.68,2.63,6.31,4.45A84.42,84.42,0,0,1,118.35,334.49Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.63,365.83c0-.87,0-1.73,0-2.58-.29-24.43-4.6-33.55-5.73-33.81l-.12-1.12a1.31,1.31,0,0,1,1,.37c2.25,1.95,5.69,12.76,6,34.56,0,.85,0,1.69,0,2.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.14,314.11s5.34-1.87,5,0-12.67,7.05-9.54,10.25,9-3.28,11-3.52,3.21,4.15,10.07,4.4,8.51-4.46,2.52-8-8.07-5.89-11.66-5.6S99.68,310.82,94.14,314.11Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.63,359.91c0-.86,0-1.72,0-2.57-.29-24.43-7.66-44.35-8.79-44.61l-.12-1.13a1.27,1.27,0,0,1,1,.38c2.25,1.95,8.75,23.56,9,45.35,0,.86,0,1.7,0,2.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.61,378.43c0-.72,0-11.12,0-15v-1.53c0-23.39,3.56-35,6-37.1a1.31,1.31,0,0,1,1-.4l-.15,1.13c-1.18.28-5.71,10.08-5.71,36.37v1.53c0,3.92,0,14.31,0,15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123,416.21H99.62a3.92,3.92,0,0,1-3.91-3.6l-2.36-29a3.91,3.91,0,0,1,3.9-4.23H125.4a3.91,3.91,0,0,1,3.9,4.23l-2.36,29A3.91,3.91,0,0,1,123,416.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "132.02 381.27 90.33 381.27 89.58 376.37 132.77 376.37 132.02 381.27",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "132.02 381.27 90.33 381.27 89.58 376.37 132.77 376.37 132.02 381.27",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.73,325.68c-2.09.31-4.42.83-5.57,2.6-1.28,2-.4,4.84,1.54,6.15a6.94,6.94,0,0,0,6.72.22c1.32-.62,2.47-1.55,3.79-2.18,3.8-1.82,8.29-.9,12.39.06-2.64,3.13-6.95,4.31-11,4.64s-8.24,0-12.25.77-8.08,3.11-9.48,7a1.77,1.77,0,0,0-.15,1,1.88,1.88,0,0,0,.84,1.07c3.52,2.52,20.41-6.25,24.71-5.75-5.71,9.16-28.52,10.19-27.2,23.15.05.57-.12,1.22.26,1.65.55.64,1.57.45,2.35.13,7.79-3.14,13-12.4,21.41-12.47Q77,356.87,75.89,360a9.6,9.6,0,0,0-.74,4,3.29,3.29,0,0,0,2.36,3c2.1.4,3.63-1.91,4.44-3.89a91.56,91.56,0,0,0,4.85-15.88c2.13.7,2.19,3.63,2.1,5.88s.95,5.28,3.17,4.93A3.25,3.25,0,0,0,93.88,357c2.41-2.6,2.78-6.48,2.58-10s-.82-7.16.06-10.59c1.15,1.65,2.38,3.38,4.22,4.2s4.43.3,5.15-1.58c.28-.74-.25-9.66-.63-10.34-1.57-2.83-5.72-2.83-8.59-3.2A100,100,0,0,0,69.73,325.68Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.32,353.73c.1,1.87.37,4,1.84,5.12a4.15,4.15,0,0,0,5.54-.87,6.14,6.14,0,0,0,.74-5.9c-.45-1.22-1.17-2.31-1.62-3.52-1.3-3.5-.13-7.38,1.05-10.92,2.54,2.58,3.24,6.47,3.2,10.1s-.69,7.26-.3,10.86,2.08,7.38,5.36,8.92a1.68,1.68,0,0,0,.86.21,1.61,1.61,0,0,0,1-.66c2.51-2.89.15-8.12-.88-11.81s-.68-6.3.11-10.05c4.07,15.33,14.14,23.81,20.08,25.19a1.81,1.81,0,0,0,1.48-.1c.61-.43.52-1.35.3-2.06-2.14-7.12-14.06-12.19-13.44-19.6l5.44,2.42a8.62,8.62,0,0,0,3.47,1,2.92,2.92,0,0,0,2.84-1.84c.52-1.82-1.39-3.35-3.07-4.22a79.35,79.35,0,0,0-13.61-5.56c.79-1.83,3.38-1.64,5.35-1.38s4.73-.41,4.61-2.4a2.92,2.92,0,0,0-.85-1.69c-2.1-2.33-5.49-3-8.63-3.08s-6.38.15-9.34-.9a9.94,9.94,0,0,0,4-3.38c.87-1.56.62-3.89-1-4.67a47.66,47.66,0,0,0-9.17-.28c-2.62,1.16-3,4.81-3.51,7.31A88.35,88.35,0,0,0,113.32,353.73Z",
    style: {
      fill: "#407BFF"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulletjournalRafiki);
export default __webpack_public_path__ + "static/media/Bullet journal-rafiki.8a6fc93dc9b6d91a54da3c452f25ef90.svg";
export { ForwardRef as ReactComponent };